  import {
    Alert,
    Avatar,
    AvatarGroup,
    Badge,
    Box,
    Button,
    ButtonGroup,
    Chip,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    Input,
    Modal,
    Paper,
    Stack,
    Typography
  } from "@mui/material";
  import axios from "axios";
  import React, { useState, useEffect, useMemo, useCallback, memo } from "react";
  // import { Link } from "react-router-dom";
  import { baseURL } from "../../api";
  import { Icon } from "../../utils/MuiIcons/Icon";
  import { useNavigate, useLocation } from "react-router-dom";
  import { validateTextField, globalvalidateTextField } from "../../utils/validations/Validation";
  import TableComponent from "../TableComponent/TableComponent";
  import DataGridComponent from "../DataGridComponent/DataGridComponent";
  import BasicTabs from "../TabComponent/TabComponent";
  import FormBar from "./formmenu";
  import dayjs from "dayjs";
  import DataTableComponent from "../DataTableComponent/DataTableComponent";
  import Accordion from "@mui/material/Accordion";
  import AccordionSummary from "@mui/material/AccordionSummary";
  import AccordionDetails from "@mui/material/AccordionDetails";
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
  import {
    renderTypography,
    renderTextfield,
    renderlinkfield,
    renderCounter,
    renderCurrency,
    renderFixedvalue,
    renderAutoComplete,
    rendercheckbox,
    renderTransferList,
    renderRadioGroup,
    renderSelect,
    renderImage,
    renderDatecomponent,
    renderButtonComponent,
    renderCardComponent,
    avatarcomponent,
    rendervartextcomponent,
    renderglobaltextcomponent,
    renderdialogboxcomponent,
    renderNestedDialog
  } from "../hooks/ComponentsData";
  import ReportsDesigner from "../reports/ReportDesigner";

  import { serverAddress } from "../../config";
  import ListItemdata from "../../component/ListItem/ListItem";
  import MessageError from "./MessageError";
  import { collectQuantityConversionPayloadMap } from "./quantityConversionPayload";
  import CustomAlert from "../../component/AlertComponent/Alert";
  import TitleHeader from "../../component/TitleHeader/TitleHeader";
  import { resolveTitleTemplate } from "../../component/TitleHeader/titleTemplate";
  import useFormCopyRules from "../../utils/formRules/useFormCopyRules";
  import FormFooter from "../../component/FormFooter/FormFooter";
  import { Global_Data } from "../../globalData/GlobalData";
  import Varselect from "../../component/VarSelect/Varselect";
  import NUMBER from "../../component/NUMBER/NUMBER";
  import Loadfrom from "../../component/Loadfrom/Loadfrom";
  import Counter from "../../component/Counter/Counter";
  import ButtonDropdown from "../../component/Button Dropdown/ButtonDropdown";
  import FileUpload from "../../component/FileUpload/FileUpload";
  import Multirecord from "../TableComponent/Multirecord";
  import MediaDialog from "../../component/MediaDialog/MediaDialog";
  import ImageComponent from "../../component/ImageComponent/ImageComponent";
  import ImgComponent from "../../component/ImgComponent/ImgComponent";
  import AlertPopup from "../../component/AlertComponent/AlertPopup";
  import SSEInfoAlert from "../../component/AlertComponent/SSEInfoAlert";
  import { formatBulkOperationMessage } from "../DataGridComponent/bulkActionAccess";
  import Vartext from "../../component/VARTEXT/Vartext";
  import AccordianComponent from "../../component/Accordian/AccordianComponent";
  import AllTablesMain from "../TableComponent/AllTablesMain";
  import Child from "./Child";
  import VarValue from "../../component/Accordian/VarValue";
  import DocumentSelect from "../../component/DocumentSelect/DocumentSelect";
  import EVENT from "../../component/EVENT/EVENT";
  import Spinner from "../../component/spinner/Spinner";
  import VarDateTime from "../../component/VARDATETIME/VarDateTime";
  import CUSTOMBOX from "../../component/CUSTOMBOX/CUSTOMBOX";
  import OverLayDrawer from "../../component/OverLayDrawer/OverLayDrawer";
  import VARCUSTOMHTML from "../../component/VARCUSTOMHTML/VARCUSTOMHTML";
  import SECTION from "../../component/SECTION/SECTION";
  import VarConcat from "../../component/VarConcat/VarConcat";
  import DialogDrawer from "../../component/DialogDrawer/DialogDrawer";
  import VARGROUP from "../../component/VARGROUP/VARGROUP";
  import VARNUMBER from "../../component/VARNUMBER/VARNUMBER";
  import VarImage from "../../component/VARIMAGE/VarImage";
  import ListenerSection from "../../component/LISTENER-SECTION/ListenerSection";
  import RenderBarchart from "../../component/Charts/BARCHART";
  import RenderLineChart from "../../component/Charts/LINECHART";
  import RenderPieChart from "../../component/Charts/PIECHART";
  import RenderVarstore from "../../component/VARSTORE/RenderVarstore";
  import RenderSwitchComponent from "../../component/Switch/SWITCH";
  import RenderInputComponent from "../../component/InputComponent/INPUT";
  import RenderTreeComponent from "../../component/Tree/TREE";
  import RenderPasswordTextfield from "../../component/PasswordTextfield/PASSWORDTEXTFIELD";
  import DateRangeComponent from "../DateComponent/DateRangeComponent";
  import DateTimeComponent from "../DateComponent/DateTimeComponent";
  import DateTimeRangeComponent from "../DateComponent/DateTimeRangeComponent";
  import ReportBrowser from "../../component/REPORTBROWSER/ReportBrowser";

  const collectDefaultInputTableNames = components => {
    const names = [];

    const visit = items => {
      if (!Array.isArray(items)) return;

      items.forEach(item => {
        if (
          item?.component?.sType === "INPUTTABLE" &&
          item?.component?.options?.mode === "DEFAULT" &&
          item?.component?.sName
        ) {
          names.push(item.component.sName);
        }

        visit(item?.child);
        visit(item?.details);
      });
    };

    visit(components);
    return [...new Set(names)];
  };

  const Form = ({ route, setFetchMainApi }) => {
    // const parseURL = urlString => {
    //   try {
    //     // Find the index of "?" in the URL
    //     const queryIndex = urlString.indexOf("&");
    //     // Extract the pathname
    //     const pathname = queryIndex !== -1 ? urlString.slice(0, queryIndex) : urlString;
    //     // Extract the search  query
    //     const searchQuery = queryIndex !== -1 ? urlString.slice(queryIndex) : "";
    //     // Return the results
    //     return { pathname, searchQuery };
    //   } catch (error) {
    //     // Handle invalid URLs
    //     return null;
    //   }
    // };
    const navigate = useNavigate();
    const location = useLocation();
    const {
      token,
      LogoutOnError,
      setHandleClickOpen,
      modalEditData,
      setModalEditData,
      textValue,
      modalActionTypeAndID,
      setTextValue,
      openModalData,
      setOpenModalData,
      open,
      isAlertPopup,isDialogDrawerOpen,
      setOpen,
      fetchDataHandleDataGrid,
      globalFormData,
      setGlobalFormData,
      setModalPrimaryKry,
      modalPrimaryKey,
      fetchFormaData1,
      freeFormInitState,
      setOverLaySplit,
      overlaySplit,
      setFreeFormInitState,
      mainFormData,
      setmainFormData,
      overLayDataFetchApi,
      defaultTableSummaryData,
      setDefaultTableSummaryData,
      setglobalvariables,
      globalvariables,
      freeFromtableRowDataStore,
      setFormData,
      formData,
      sAlertPopup,varCustomDialogData,
      overlaySplitOldData,
      setOverLaySplitOldData,
      setIsAlertPopup,
      setFreeFromTableRowDataStore,
      openModalChildData,
      openModalDataActive,
      defaultTableSummaryFeild,
      isoverLayDataLoading,
      setdefaultTableSummaryFeild,
      setisPageLoading,
      isPageLoading,
      nestedDialog,
      setNestedDialog,varCutomDialogApi,
      isOpenModalChildData,
      setIsOpenModalChildData,
      setOpenModalChildData,varCustomDialogTitle,
      sideBarStyle,setFreeFormToDefault,
      setDefaultTableSelectedLocation,
      setDefaultTableSelectedDataAwareData,
      setDefaultTableSelectedSupplier,
      setDebugSectionAPIData,
      setOpenDebugSection,
      freeFormDataSubmit,
      sectionComponentDataAware,
      setSectionComponentDataAware,
      conversionNamesMapping,
      setConversionNamesMapping,
      setSubmitPayloadLoading,
      shippingId,
      bulkData,
      setDialogDrawerOpen
    } = Global_Data?.() || {};

    useFormCopyRules(formData, textValue, setTextValue);

    const [formMetadata, setformMetata] = useState();
    const [IsTable, setIsTable] = useState(false);
    const [freeFromTotals, setFreeFromTotals] = useState("0.00");
    const [freeFormTabbleArrays, setFreeFormTabbleArrays] = useState([]);
    const [freeFormTabbleEditArrays, setFreeFormTabbleEditArrays] = useState([]);
    const [freeFormTabbleEditMainrecord, setFreeFormTabbleEditMainrecord] = useState([]);
    const [varValue, setVarValue] = useState({});
    const [error, setError] = useState({});
    const [index, setIndex] = useState(-1);
    const [tablesampledata, SetTabledata] = useState();
    const [summaryfields, setsummaryfields] = useState();
    const [freeformdata, setFreeformfield] = useState();
    const [defaultTableMode, setDefaultTableMode] = useState("");
    const [defaultTableName, setDefaultTableName] = useState("");
    const [freeformTableMode, setFreeformTableMode] = useState("");
    const [debitCreditTableMode, setdebitCreditTableMode] = useState("");
    const [debitCreditTotal, setdebitCreditTotal] = useState({});
    const [debitCreditTotalBalanced, setdebitCreditTotalBalanced] = useState(true);
    const [debitCreditTableData, setdebitCreditTableData] = useState([]);
    const [debitCreditTableName, setdebitCreditTableName] = useState("");
    const [freeformTableName, setFreeformTableName] = useState("");
    const [filterDefault, setfilterDefault] = useState();
    const [differenceDebitCredit, setdifferenceDebitCredit] = useState(1);
    const [filterFreeform, setfilterfreeForm] = useState();
    const [isSubmited, setIssubmited] = useState(false);
    const [formIsSubmited, setformIsSubmited] = useState(false);
    const [globalError, setGlobalError] = useState("");
    const [tableMianData, setTablemaindata] = useState("");
    const [validaterules, setValidationRules] = useState({});
    const [singlefileImg, setSingleImg] = useState();
    const [handleModalclick, sethandleModalclick] = useState(false);
    const [multiplefileImg, setmultiplefileImg] = useState({});
    const [imageuploadURL, setImgUploadURL] = useState("");
    const [isDisabledTable, setIsDisabledTable] = useState(false);
    const [isFileUpload, setIsFileUpload] = useState([]);
    const [filesForBackend, setFilesForBackend] = useState([]);
    const [editFiledata, setEditFormFiles] = useState([]);
    const [multiRecordForBackend, setMultiRecordForBackend] = useState([]);
    const [imagesIdsFromMedia, setImagesIdsFromMedia] = useState([]);
    const [bPayloads, setbPayloads] = useState({});
    const [bPayloadsDailog, setbPayloadsDailog] = useState({});
    const [bPayloadsDailogOld, setbPayloadsDailogOld] = useState({});
    const [selectAndAutocompleteSname, setSelectAndAutocompleteSname] = useState("");
    const [freeFormValidateFunction, setfreeFormValidateFunction] = useState();
    const [multirecordValidateFunction, setmultirecordValidateFunction] = useState();
    const [defaultTableValidateFunction, setdefaultTableValidateFunction] = useState();
    const [debitCreditValidateFunction, setdebitCreditValidateFunction] = useState();
    const [multirecordExist, setmultirecordExist] = useState(false);
    const [selectedRowsDataGrid, setselectedRowsDataGrid] = useState([]);
    const [documentSelectTableData, setdocumentSelectTableData] = useState([]);
    const [documentSelectMainRecordData, setDocumentSelectMainRecordData] = useState("");
    const [documentSelectMainRecordObject, setDocumentSelectMainRecordObject] = useState("");
    const [documentSelectmappingData, setdocumentSelectmappingData] = useState({});
    const [documentSelectKey, setDocumentSelectKey] = useState("");
    const [openModalFreeFormName, setopenModalFreeFormName] = useState([]);
    const [dataGridModalOpen, setDataGridModalOpen] = useState(false);
    const [uniqueErrors, setUniqueErrors] = useState([]);
    const [initialEditData, setInitialEditData] = useState();
    const [isResponseArrived, setIsResponseArrived] = useState(true);
    const [isEditRecordHydrated, setIsEditRecordHydrated] = useState(false);
    const [defaultTableHydration, setDefaultTableHydration] = useState({});
    const [defaultTableNameAndModel, setdefaultTableNameAndModel] = useState({});
    const [dTermDays, setdTermDays] = useState(0);
    const [selectedComponentData, setSelectedComponentData] = useState({});
    const [dialogKeyMapping, setDialogKeyMapping] = useState({});
    const [checkMaxTotalValue, setcheckMaxTotalValue] = useState("");
    const [allowZeroValue, setallowZeroValue] = useState("");
    const [nestedDialogMode, setNestedDialogMode] = useState({});
    const [isDocumentSelect, setIsDocumentSelect] = useState(false);
    const [refreshData, setRefreshData] = useState(false);
    const [dataGridRetention, setDataGridRetention] = useState();
    const [currencyOptions, setCurrencyOptions ] = useState([]);
    const [selectedCurrency, setSelectedCurrecy] = useState("");
    const [eventSelectTableData, setEventSelectTableData] = useState();
    const [eventSelectTableMapping, setEventSelectTableMapping] = useState();
    const [reportData, setReportData] = useState();
    const [bulkActionLoader, setBulkActionLoader] = useState(false);
    const [showBulkActionLoading, setShowBulkActionLoading] = useState(false);
    const [isViewDataLoading, setIsViewDataLoading] = useState(false);

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [mainPayloads, setMainPayloads] = useState({});


    // alert('dd')

    const [recordData, setRecordData] = useState({});
    const urlCapture = window.location.pathname + window.location.search;
    const defaultInputTableNames = useMemo(
      () => collectDefaultInputTableNames(formData?.details),
      [formData?.details]
    );
    const requiresDefaultTableHydration =
      String(formData?.form?.sFormAction || "").toUpperCase() === "EDIT" &&
      defaultInputTableNames.length > 0;
    const defaultTablesReady =
      !requiresDefaultTableHydration ||
      (
        isEditRecordHydrated &&
        defaultInputTableNames.every(tableName => {
          const hydration = defaultTableHydration?.[tableName];
          return hydration?.recordKey === urlCapture && hydration?.ready === true;
        })
      );

      // dialog

    const [dialogMode, setDialogMode] = React.useState();
    const [dialogTextValue, setDialogTextValue] = useState({});

    const openRef = React.useRef(open);
    openRef.current = open;
    const isOpenModalChildDataRef = React.useRef(isOpenModalChildData);
    isOpenModalChildDataRef.current = isOpenModalChildData;

    function handleClickOpen(mode) {
      const dialogRoute = mode?.options?.dialog || "";

      setDialogTextValue(textValue);
      setError(null);
      sethandleModalclick(true);

      /*
      * Menu dialog example:
      *
      * purchaseOrder_cancel_dialog?doc=PO-000001
      *
      * Store the query parameter as:
      *
      * textValue.doc = "PO-000001"
      */
      if (dialogRoute.includes("?")) {
        try {
          const queryString = dialogRoute.substring(
            dialogRoute.indexOf("?") + 1
          );

          const searchParams = new URLSearchParams(queryString);
          const dialogParameters = {};

          searchParams.forEach((value, key) => {
            dialogParameters[key] = value;
          });

          if (Object.keys(dialogParameters).length > 0) {
            setTextValue(prev => ({
              ...(prev || {}),
              ...dialogParameters
            }));

            setVarValue(prev => ({
              ...(prev || {}),
              ...dialogParameters
            }));
          }
        } catch (error) {
          console.error(
            "[Form.js] Failed to parse dialog parameters:",
            dialogRoute,
            error
          );
        }
      }

      const currentlyOpen = openRef.current;
      const currentlyNested = isOpenModalChildDataRef.current;

      if (mode?.options?.nested) {
        setNestedDialogMode(mode);
        setNestedDialog(true);
        setOpen(true);
      } else if (currentlyOpen && !currentlyNested) {
        setNestedDialogMode({
          ...mode,
          options: {
            ...mode.options,
            nested: true
          }
        });

        setNestedDialog(true);
      } else if (!currentlyOpen) {
        setDialogMode(mode);
        setOpen(true);
      }
    }

    const handleButtonTerminateSignal = () => {
    handleClose();

    if (fetchDataHandleDataGrid?.fetchDataHandleDataGrid) {
      fetchDataHandleDataGrid.fetchDataHandleDataGrid(fetchDataHandleDataGrid.uri);
    }

    setRefreshData(true);
  };

    useEffect(() => {
      setHandleClickOpen(() => handleClickOpen);
    }, []);

    const handleClose = () => {
      // This flag suppresses DataGrid loading while a grid-owned dialog is
      // active. It must be released for every close path (success, business
      // error, warning, transport error, or user dismissal), otherwise the
      // next routed DataGrid skips its initial request entirely.
      setDataGridModalOpen(false);

      if (isOpenModalChildData) {
        setbPayloadsDailog(bPayloadsDailogOld);
        setIsOpenModalChildData(false);
        setNestedDialog(false);
      } else {
        setOpen(false);
        setNestedDialog(false);
        setNestedDialogMode({});
      }

      removeFreeFormTable(openModalChildData);
      setTextValue(dialogTextValue);
      setModalEditData({});
      sethandleModalclick(false);

    };
    function removeFreeFormTable(data) {
      for (let i = 0; i < data?.length; i++) {
        let obj = { ...data[i] };
        if (obj?.component?.options?.mode === "FREEFORM") {
          setopenModalFreeFormName(preState => [...preState, obj.component.sName]);

        }
      }
    }
    const [company, setCompany] = useState({});
    const [user, setUser] = useState({});
    const [format, setFormat] = useState([]);

function fetchFormaData() {
  setdocumentSelectTableData([]);
  setdocumentSelectmappingData({});
  return fetchFormaData1();
}

  const formatToMMDDYYYY = (date) => {
    return date ? dayjs(date).format("MM-DD-YYYY") : "";
  };

  const findComponentByName = (items = [], sName) => {
    for (const item of items || []) {
      if (item?.component?.sName === sName) return item;

      const childResult = findComponentByName(item?.child, sName);
      if (childResult) return childResult;

      const fixColumnResult = findComponentByName(item?.fixcolumns, sName);
      if (fixColumnResult) return fixColumnResult;
    }

    return null;
  };

  const isPhysicallyVisible = value => {
    const componentName = String(value || "").replace(/[{}]/g, "");
    if (!componentName) return true;

    const element =
      document.getElementById(componentName) ||
      document.querySelector(`[id^="${componentName}-"]`) ||
      document.querySelector(`[id^="${componentName}"]`);

    if (!element) return false;

    let current = element;

    while (current && current !== document.body) {
      const style = window.getComputedStyle(current);

      if (
        style.display === "none" ||
        style.visibility === "hidden" ||
        style.opacity === "0"
      ) {
        return false;
      }

      current = current.parentElement;
    }

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

    useEffect(() => {
      setdocumentSelectTableData([]);
      setdocumentSelectmappingData({});
      setEventSelectTableData();
      setEventSelectTableMapping();

      // setdebitCreditTableMode(null);
      return () => {
        setformIsSubmited(false);
        setdocumentSelectTableData([]);
        setFreeFromTableRowDataStore([]);
        setdocumentSelectmappingData({});
        setTextValue({});
        setdefaultTableSummaryFeild("");
        setdefaultTableSummaryFeild({});
        setVarValue({});
        setdebitCreditTableMode(null);
        setfilterDefault([]);
        setFreeFormTabbleArrays([]);
        setdebitCreditTableData([]);
        setMultiRecordForBackend([]);
        setmultirecordValidateFunction(false);
        setmultirecordExist(false);
        setfreeFormValidateFunction(false);
        setdefaultTableValidateFunction(false);
        setdebitCreditValidateFunction(false);
        setIsDisabledTable(false);
        setFreeFormTabbleEditArrays([]);
        setImagesIdsFromMedia([]);
        setFreeFormTabbleArrays([]);
        setfilterfreeForm(undefined);
        setEditFormFiles([]);
        setIsDocumentSelect(false);
        setReportData();
      };
    }, [route, urlCapture]);

    useEffect(() => {
      // React Router reuses this Form instance between form routes. Refresh the
      // navbar callback as the route changes so it does not retain the form
      // (usually dashboardmain) that was active when Form first mounted.
      setFetchMainApi(() => () => {
        if (window.location.pathname === "/login") {
          console.warn("[Form.js] Blocked external fetchFormaData call on /login");
          return;
        }

        fetchFormaData();
      });
    }, [route, setFetchMainApi, fetchFormaData1]);

    useEffect(() => {
      window.scrollTo(0, 0);
      // React Router reuses Form between routes. Never carry a grid-dialog
      // loading lock into the next form when navigation follows an action.
      setDataGridModalOpen(false);
    }, [route]);

    const getFieldValue = sName => {
      const [orgKey, fieldName] = sName?.split(".") ?? [];
      switch (orgKey) {
        case "organization":
          return company?.data?.[fieldName];
        case "user":
          return user?.data?.[fieldName];
        case "format":
          return format?.data?.[fieldName];
        default:
          return undefined;
      }
    };

    //  working
    const [bodycontent, setBodycontent] = useState([]);

    useEffect(() => {
      axios
        .get(`${serverAddress}/record/get/all/sys_formatting`, {
          headers: {
            Authorization: `Bearer ${token}`
            // Other headers if needed
          }
        })
        .then(formatResponse => {
          setFormat(formatResponse.data);
        })
        .catch(() => {
          // setGlobalError(error);
        });

      axios
        .get(`${serverAddress}/globalvariables/all`, {
          headers: {
            Authorization: `Bearer ${token}`
            // Other headers if needed
          }
        })
        .then(response => {
          localStorage.setItem("globalvariables", JSON.stringify(response.data.data.globalvariables));

          setglobalvariables(response.data.data.globalvariables);
        })
        .catch(() => {
          // setGlobalError(error);
        });
    }, [formData, route, urlCapture]);
    // edit table form.sFormSource

    let url = "";
    let recordId = "";

    if (location?.state?.id) {
      recordId = location.state.id;
    } else {
      const searchParams = new URLSearchParams(window.location.search);
      recordId = searchParams.get("id") || "";

      const next = searchParams.get("next");
      const pre = searchParams.get("pre");

      if (!recordId && !pre && !next) {
        const idPart =
          window.location.href.split("?id=")[1] ||
          window.location.href.split("&id=")[1] ||
          "";

        recordId = idPart.split("&")[0] || "";
      }
    }

    if (formData?.form?.sFormSource && recordId) {
      url = formData.form.sFormSource.endsWith("/")
        ? `${formData.form.sFormSource}${recordId}`
        : `${formData.form.sFormSource}/${recordId}`;
    }

      let id3 = "";

      try {
        if (varCutomDialogApi) {
          const urlObj = new URL(baseURL + varCutomDialogApi);
          id3 = urlObj.searchParams.get("id") || "";
        }
      } catch (error) {
        console.warn("[Form.js] Invalid varCutomDialogApi:", varCutomDialogApi);
      }

      const dialogURI =
        varCustomDialogData?.form?.sFormSource && id3
          ? `${baseURL}${varCustomDialogData.form.sFormSource}${id3}`
          : "";


    const isRecordViewOrEdit =
    formData?.form?.sFormAction === "VIEW" ||
    formData?.form?.sFormAction === "EDIT" ||
    formData?.form?.sFormType === "VIEW" ||
    formData?.form?.sFormType === "EDIT";

    const shouldLoadRecordData = Boolean(
      (
        (isRecordViewOrEdit && url && recordId) ||
        (isDialogDrawerOpen && dialogURI)
      ) &&
      formData?.form?.sFormSource
    );

    function convertNumericToString(obj) {
      for (let key in obj) {
        if (typeof obj[key] === "number") {
          obj[key] = obj[key].toString();
        }
      }
      return obj;
    }

      
      useEffect(() => {
      if (shouldLoadRecordData) {
        setIsViewDataLoading(true);
        setIsResponseArrived(false);
        setIsEditRecordHydrated(false);
        setDefaultTableHydration({});

        const recordUrl = isDialogDrawerOpen ? dialogURI : `${baseURL}${url}`;

        if (!recordUrl || recordUrl.includes("/login")) {
          console.warn("[Form.js] Blocked invalid record load URL:", recordUrl);
          setIsViewDataLoading(false);
          setIsResponseArrived(true);
          return;
        }
        
        if (!recordUrl || recordUrl.endsWith("/") || recordUrl.includes("/undefined")) {
          console.warn("[Form.js] Blocked invalid VIEW/EDIT record URL:", recordUrl);
          setIsViewDataLoading(false);
          setIsResponseArrived(true);
          return;
        }

        const request = location?.state?.method === "POST"
          ? axios.post(recordUrl, null, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            })
          : axios.get(recordUrl, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            });

        request
          .then(response => {
            const data =
              response?.data?.data?.mainrecord ||
              response?.data?.data?.records?.[0] ||
              {};

            setFreeFormTabbleEditArrays(response?.data?.data?.tablerecords);
            setFreeFormTabbleEditMainrecord(response?.data?.data?.mainrecord);
            setEditFormFiles(response?.data?.data?.files);

            const convertedData = convertNumericToString({ ...(data || {}) });

            setVarValue(convertedData || {});
            setInitialEditData(convertedData || {});
            setRecordData(response.data);
            setBodycontent(response?.data?.data?.[1]?.imagerecords);
            setIsEditRecordHydrated(true);
          })
          .catch(error => {
            setGlobalError(error);

            if (error?.response?.status === 401) {
              localStorage.clear();
              navigate("/login");
            }
          })
          .finally(() => {
            setIsViewDataLoading(false);
            setIsResponseArrived(true);
          });
      } else {
        setIsViewDataLoading(false);
        setIsEditRecordHydrated(false);
        setDefaultTableHydration({});
        SettingInitialValues({ preserveExisting: true });
        setBodycontent([]);
        sethandleModalclick(false);
      }
    }, [
      shouldLoadRecordData,
      url,
      formData,
      location?.state?.id,
      location?.state?.method,
      isDialogDrawerOpen
    ]);

    const collectRequiredFieldErrors = (components = [], values = {}) => {
      let requiredErrors = {};

      components?.forEach(item => {
        const sType = item?.component?.sType;
        const sName = item?.component?.sName;
        const validation = item?.validation;

        // Do not validate child form/table definitions as main form fields
        if (
          sType === "DIALOG" ||
          sType === "INPUTTABLE" ||
          sType === "MULTIRECORD"
        ) {
          return;
        }

        const isPayload = item?.data?.bPayload == 1;
        const isRequired = validation?.bRequired == 1;

        if (sName && isPayload && isRequired) {
          const value = values?.[sName];

          const normalizedValue =
            value?.target?.value ??
            value?.value ??
            value;

          const isEmpty =
            normalizedValue === undefined ||
            normalizedValue === null ||
            String(normalizedValue).trim() === "";

          if (isEmpty) {
            requiredErrors[sName] =
              validation?.sErrorMessage ||
              item?.component?.sHelper ||
              "This field is required";
          }
        }

        if (Array.isArray(item?.child)) {
          requiredErrors = {
            ...requiredErrors,
            ...collectRequiredFieldErrors(item.child, values)
          };
        }
      });

      return requiredErrors;
    };

    function findMatchingFields(dialogform, modalEditData) {
      const matchingFields = {};

      for (const key in dialogform) {
        if (modalEditData?.hasOwnProperty(key)) {
          // matchingFields[key] = dialogform[key] !== '' ? dialogform[key]:modalEditData[key];
          matchingFields[key] = modalEditData[key] == null ? "" : modalEditData[key];
        } else {
          matchingFields[key] = dialogform[key];
        }
      }
      return matchingFields;
    }

    const isUnresolvedDialogTemplateValue = value =>
      typeof value === "string" &&
      /^\s*(?:\[[^\]]+\]|\{[^}]+\})\s*$/.test(value);

    function mergeDialogFieldsPreservingResolvedValues(previous, incoming) {
      const merged = { ...(previous || {}) };

      Object.entries(incoming || {}).forEach(([fieldName, incomingValue]) => {
        const previousValue = merged[fieldName];
        const previousIsConcrete =
          previousValue !== undefined &&
          previousValue !== null &&
          String(previousValue).trim() !== "" &&
          !isUnresolvedDialogTemplateValue(previousValue);

        if (isUnresolvedDialogTemplateValue(incomingValue) && previousIsConcrete) {
          return;
        }

        merged[fieldName] = incomingValue;
      });

      return merged;
    }

    useEffect(() => {
      if (!initialEditData) return;

      setTextValue(prev => {
        const rtnData = copyMatchingValues(initialEditData, prev);

        const isSame =
          JSON.stringify(prev || {}) === JSON.stringify(rtnData || {});

        return isSame ? prev : rtnData;
      });
    }, [initialEditData]);

    function copyMatchingValues(backendObj, frontendObj) {
      const result = { ...(frontendObj || {}) };

      if(backendObj.hasOwnProperty("sAccountTo") && formData?.form?.sFormAction === "EDIT"){
        frontendObj["sAccountTo"] = "";
      }
      for (const key in backendObj || {}) {
        result[key] = backendObj[key];
      }

      // console.log("after copyMatchingValues", {
      //   backend_sBrand: initialEditData?.sBrand,
      //   textValue_sBrand: textValue?.sBrand
      // });

      return result;
    }
    
    const dateformat = (date, sourceFormat = "YYYY-MM-DD", returnFormat) => {
      if (date) {
        const parseDate = (date, format) => {
          const parts = date?.split('-');
          const formatParts = format.toLowerCase().split('-');
          const dateObj = {};
    
          formatParts.forEach((part, index) => {
            dateObj[part] = parseInt(parts[index], 10);
          });
    
          return new Date(dateObj.yyyy, dateObj.mm - 1, dateObj.dd);
        };
    
        const formatDate = (dateObj, format) => {
          const dd = String(dateObj.getDate()).padStart(2, '0');
          const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
          const yyyy = dateObj.getFullYear();
    
          switch (format) {
            case 'dd-mm-yyyy':
              return `${dd}-${mm}-${yyyy}`;
            case 'yyyy-dd-mm':
              return `${yyyy}-${dd}-${mm}`;
            case 'yyyy-mm-dd':
              return `${yyyy}-${mm}-${dd}`;
            case 'mm-dd-yyyy':
              return `${mm}-${dd}-${yyyy}`;
            default:
              return '';
          }
        };
    
        // Convert sourceFormat and returnFormat to lowercase
        const parsedDate = parseDate(date, sourceFormat.toLowerCase());
    
        if (isNaN(parsedDate)) {
          return '';
        }
        // alert(formatDate(parsedDate, returnFormat?.toLowerCase()))
        return formatDate(parsedDate, returnFormat?.toLowerCase());
      } else {
        return '';
      }
    };
    
    
  //   const dateformat = (date, dateFormat) => {
  //     const d = new Date(date);
      
  //     // Check for an invalid date

  //     if (isNaN(d)) {
  //       return "Invalid date";
  //     }


  //     const dd = d.getDate().toString().padStart(2, "0");
  //     const mm = (d.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  //     const yyyy = d.getFullYear();

  //     let month = ("0" + (d.getMonth() + 1)).slice(-2); // getMonth() returns month index from 0 to 11
  // let day = ("0" + d.getDate()).slice(-2);
  // let year = d.getFullYear();
    
  //     switch (dateFormat) {
  //       case "DD-MM-YYYY":
  //         return `${dd}-${mm}-${yyyy}`;
  //       case "YYYY-DD-MM":
  //         return `${yyyy}-${dd}-${mm}`;
  //       case "YYYY-MM-DD":
  //         return `${yyyy}-${mm}-${dd}`;
  //       case "MM-DD-YYYY":
  //         return `${month}-${day}-${year}`;
  //       default:
  //         return "Invalid date format pattern";
  //     }
  //   };


    // function getOpenDialogType(){
    // let type = '';

    // for (let i = 0; i < formData?.details?.length; i++) {
    //   const element = formData?.details?.[i]

    //   if (element..component.sFormAction) {

    //   }
    // }

    // }

    function createDiaLogForm(maindata, dialogform, dialogformvalidate) {
      maindata?.forEach((data) => {
        switch (data?.component?.sType) {
          case "TEXTFIELD":
          case "COUNTER":
          case "AUTOCOMPLETE":
          case "PASSWORDTEXTFIELD":
          case "FIXVALUE":
          case "CHECKBOX":
          case "TRANSFERLIST":
          case "VARTEXT":
          case "VARNUMBER":
          case "VARIMAGE":
          case "IMG":
          case "VARCONCAT":
          case "SELECT":
          case "NUMBER":
          case "VARSELECT":
          case "IMAGE":
          case "INPUT":
            dialogform[data?.component?.sName] =
              data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
            dialogformvalidate[data?.component?.sName] = data?.validation;
            break;
          case "BOX":
            createDiaLogForm(data?.child, dialogform, dialogformvalidate)
            break;
          case "SECTION":
            createDiaLogForm(data?.child, dialogform, dialogformvalidate)
            break;
          case "DOCUMENTSELECT":
            createDiaLogForm(data?.child, dialogform, dialogformvalidate)
            break;
          case "DATETIME":
            dialogform[data?.component?.sName] =
              data?.component?.sDefaultValue !== ""
                ? dateformat(data?.component?.sDefaultValue,data?.component?.sSourceFormat, data?.component?.sSendFormat)
                : "";

            dialogformvalidate[data?.component?.sName] = data?.validation;
            break;
          case "DATERANGE":
            dialogform[data?.component?.sName] = {
              sStartValue: data?.component?.sStartDefault || "",
              sEndValue: data?.component?.sEndDefault || ""
            };
            dialogformvalidate[data?.component?.sName] = data?.validation;
            break;
          case "DATETIMERANGE":
            dialogform[data?.component?.sName] = {
              sStartDateValue: data?.component?.sStartDateDefault || "",
              sEndDateValue: data?.component?.sEndDateDefault || "",
              sStartTimeValue: data?.component?.sStartTimeDefault || "",
              sEndTimeValue: data?.component?.sEndTimeDefault || ""
            };
            dialogformvalidate[data?.component?.sName] = data?.validation;
            break;
          case "RADIOGROUP":
            dialogform[data?.component?.sName] = data?.component?.sProps?.defaultValue
              ? data?.component?.sProps?.defaultValue
              : " ";
    
            //   dialogform[data?.component?.sName] =
            //   data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
            dialogformvalidate[data?.component?.sName] = data?.validation;
            break;
          default:
            break;
        }
      });
    }

    useEffect(() => {
      if (!conversionNamesMapping) return;

      const conversions = Object.values(conversionNamesMapping);
      if (!conversions || conversions.length === 0) return;

      const conversionObj = {};
      conversions.forEach(value => {
        conversionObj[value] = 1;
      });

      setbPayloads(prev => {
        const alreadySame = Object.keys(conversionObj).every(
          key => prev?.[key] === conversionObj[key]
        );

        if (alreadySame) {
          return prev;
        }

        return {
          ...prev,
          ...conversionObj
        };
      });
    }, [conversionNamesMapping]);

    useEffect(() => {
      const taxtvaluecols = {};
      const validate = {};
      let dialogform = {};
      const dialogformvalidate = {};
      /* eslint-disable no-fallthrough */
      if(formData?.details?.length == 1 && formData?.details[0]?.child?.length > 0){
        formData?.details[0]?.child?.forEach(data => {
          if (handleModalclick) {
            if (data?.component?.sType === "DIALOG") {
              if (
                data?.component.sFormAction === "ADD" ||
                data?.component.sFormAction === "" ||
                data?.component.sFormAction === "EDIT" ||
                data?.component.sFormAction === "PRINT"
              ) {
                setbPayloadsDailog(predata => {
                  if (!isOpenModalChildData) {
                    setbPayloadsDailogOld(predata);
                  }
                  return payloadData(openModalChildData);
                });
    
                createDiaLogForm(openModalChildData, dialogform, dialogformvalidate);
                // openModalChildData.forEach(data => {
                //   switch (data?.component?.sType) {
                //     case "TEXTFIELD":
                //     case "COUNTER":
                //     case "AUTOCOMPLETE":
                //     case "PASSWORDTEXTFIELD":
                //     case "FIXVALUE":
                //     case "CHECKBOX":
                //     case "TRANSFERLIST":
                //     case "VARTEXT":
                //     case "VARNUMBER":
                //     case "IMG":
                //     case "VARCONCAT":
    
                //     case "SELECT":
                //     case "NUMBER":
                //     case "VARSELECT":
                //     case "IMAGE": {
                //       /* rfg 9 may 23*/
                //     }
                //     case "INPUT":
                //       dialogform[data?.component?.sName] =
                //         data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
                //       dialogformvalidate[data?.component?.sName] = data?.validation;
                //       break;
                //     // break;
                //     case "DATETIME":
                //       dialogform[data?.component?.sName] =
                //         data?.component?.sDefaultValue !== ""
                //           ? dateformat(data?.component?.sDefaultValue,data?.component?.sSourceFormat, data?.component?.sSendFormat)
                //           : "";
                          
                //       dialogformvalidate[data?.component?.sName] = data?.validation;
                //       break;
                //     case "RADIOGROUP":
                //       dialogform[data?.component?.sName] = data?.component?.sProps?.defaultValue
                //         ? data?.component?.sProps?.defaultValue
                //         : " ";
    
                //       //   dialogform[data?.component?.sName] =
                //       //   data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
                //       dialogformvalidate[data?.component?.sName] = data?.validation;
                //       break;
                //     default:
                //       break;
                //   }
                // });
              }
            }
          } else {
            switch (data?.component?.sType) {
              case "TEXTFIELD":
              case "PASSWORDTEXTFIELD":
              case "FIXVALUE":
              case "AUTOCOMPLETE":
              case "CHECKBOX":
              case "TRANSFERLIST":
              case "COUNTER":
              case "RADIOGROUP":
              case "VARSELECT":
              case "SELECT":
              case "VARCONCAT":
              case "VARTEXT":
              case "VARNUMBER":
              case "VARIMAGE":
              case "IMG":
              case "DATAGRID":
                if (data?.component?.sType === "CHECKBOX") {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                    ? data?.component?.sDefaultValue
                    : "";
                } else if (
                  (data?.component?.sType === "TEXTFIELD" && data?.validation?.sType === "COUNTER") ||
                  data?.validation?.sType === "FIXVALUE"
                ) {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                    ? data?.component?.sDefaultValue
                    : " ";
                } else if (
                  data?.component?.sType === "RADIOGROUP" &&
                  data?.component?.sProps?.defaultValue
                ) {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sProps?.defaultValue
                    ? data?.component?.sProps?.defaultValue
                    : " ";
                } else {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                    ? data?.component?.sDefaultValue
                    : "";
                  validate[data?.component?.sName] = data?.validation;
                }
                break;
              case "INPUT":
                taxtvaluecols[data?.component?.sName] =
                  data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
                validate[data?.component?.sName] = data?.validation;
                break;
              case "DATETIME":
                taxtvaluecols[data?.component.sName] =
                  dateformat(data?.component?.sDefaultValue,data?.component?.sSourceFormat, data?.component?.sSendFormat) || "";
                break;
              case "DATERANGE":
                taxtvaluecols[data?.component?.sName] = {
                  sStartValue: data?.component?.sStartDefault || "",
                  sEndValue: data?.component?.sEndDefault || ""
                };
                break;
              case "DATETIMERANGE":
                taxtvaluecols[data?.component?.sName] = {
                  sStartDateValue: data?.component?.sStartDateDefault || "",
                  sEndDateValue: data?.component?.sEndDateDefault || "",
                  sStartTimeValue: data?.component?.sStartTimeDefault || "",
                  sEndTimeValue: data?.component?.sEndTimeDefault || ""
                };
                break;
              case "NUMBER":
                taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                  ? parseFloat(data?.component?.sDefaultValue)
                  : " ";
                break;
              default:
                break;
            }
          }
        });
      } else {
        formData?.details?.forEach(data => {
          if (handleModalclick) {
            if (data?.component?.sType === "DIALOG") {
              if (
                data?.component.sFormAction === "ADD" ||
                data?.component.sFormAction === "" ||
                data?.component.sFormAction === "EDIT" ||
                data?.component.sFormAction === "PRINT" ||
                data?.component.sFormAction === "VIEW"
              ) {
                setbPayloadsDailog(predata => {
                  if (!isOpenModalChildData) {
                    setbPayloadsDailogOld(predata);
                  }
                  return payloadData(openModalChildData);
                });
    
                createDiaLogForm(openModalChildData, dialogform, dialogformvalidate);
                // openModalChildData.forEach(data => {
                //   switch (data?.component?.sType) {
                //     case "TEXTFIELD":
                //     case "COUNTER":
                //     case "AUTOCOMPLETE":
                //     case "PASSWORDTEXTFIELD":
                //     case "FIXVALUE":
                //     case "CHECKBOX":
                //     case "TRANSFERLIST":
                //     case "VARTEXT":
                //     case "VARNUMBER":
                //     case "IMG":
                //     case "VARCONCAT":
    
                //     case "SELECT":
                //     case "NUMBER":
                //     case "VARSELECT":
                //     case "IMAGE": {
                //       /* rfg 9 may 23*/
                //     }
                //     case "INPUT":
                //       dialogform[data?.component?.sName] =
                //         data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
                //       dialogformvalidate[data?.component?.sName] = data?.validation;
                //       break;
                //     // break;
                //     case "DATETIME":
                //       dialogform[data?.component?.sName] =
                //         data?.component?.sDefaultValue !== ""
                //           ? dateformat(data?.component?.sDefaultValue,data?.component?.sSourceFormat, data?.component?.sSendFormat)
                //           : "";
                          
                //       dialogformvalidate[data?.component?.sName] = data?.validation;
                //       break;
                //     case "RADIOGROUP":
                //       dialogform[data?.component?.sName] = data?.component?.sProps?.defaultValue
                //         ? data?.component?.sProps?.defaultValue
                //         : " ";
    
                //       //   dialogform[data?.component?.sName] =
                //       //   data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
                //       dialogformvalidate[data?.component?.sName] = data?.validation;
                //       break;
                //     default:
                //       break;
                //   }
                // });
              }
            }
          } else {
            switch (data?.component?.sType) {
              case "TEXTFIELD":
              case "PASSWORDTEXTFIELD":
              case "FIXVALUE":
              case "AUTOCOMPLETE":
              case "CHECKBOX":
              case "TRANSFERLIST":
              case "COUNTER":
              case "RADIOGROUP":
              case "VARSELECT":
              case "SELECT":
              case "VARCONCAT":
              case "VARTEXT":
              case "VARNUMBER":
              case "VARIMAGE":
              case "IMG":
              case "DATAGRID":
                if (data?.component?.sType === "CHECKBOX") {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                    ? data?.component?.sDefaultValue
                    : "";
                } else if (
                  (data?.component?.sType === "TEXTFIELD" && data?.validation?.sType === "COUNTER") ||
                  data?.validation?.sType === "FIXVALUE"
                ) {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                    ? data?.component?.sDefaultValue
                    : " ";
                } else if (
                  data?.component?.sType === "RADIOGROUP" &&
                  data?.component?.sProps?.defaultValue
                ) {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sProps?.defaultValue
                    ? data?.component?.sProps?.defaultValue
                    : " ";
                } else {
                  taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                    ? data?.component?.sDefaultValue
                    : "";
                  validate[data?.component?.sName] = data?.validation;
                }
                break;
              case "INPUT":
                taxtvaluecols[data?.component?.sName] =
                  data?.component?.sDefaultValue !== "" ? data?.component?.sDefaultValue : "";
                validate[data?.component?.sName] = data?.validation;
                break;
              case "DATETIME":
                taxtvaluecols[data?.component.sName] =
                  dateformat(data?.component?.sDefaultValue,data?.component?.sSourceFormat, data?.component?.sSendFormat) || "";
                break;
              case "DATERANGE":
                taxtvaluecols[data?.component?.sName] = {
                  sStartValue: data?.component?.sStartDefault || "",
                  sEndValue: data?.component?.sEndDefault || ""
                };
                break;
              case "DATETIMERANGE":
                taxtvaluecols[data?.component?.sName] = {
                  sStartDateValue: data?.component?.sStartDateDefault || "",
                  sEndDateValue: data?.component?.sEndDateDefault || "",
                  sStartTimeValue: data?.component?.sStartTimeDefault || "",
                  sEndTimeValue: data?.component?.sEndTimeDefault || ""
                };
                break;
              case "NUMBER":
                taxtvaluecols[data?.component?.sName] = data?.component?.sDefaultValue
                  ? parseFloat(data?.component?.sDefaultValue)
                  : " ";
                break;
              default:
                break;
            }
          }
        });
      }

      function validationData(data) {
        const validation = {};
        data?.forEach(elm => {
          if (elm.validation) {
            validation[elm.component.sName] = elm.validation;
          }
          if (elm.child && elm.component?.sType !== "INPUTTABLE") {
            Object.assign(validation, validationData(elm.child));
          }
        });
        return validation;
      }

      function mainPayloadData(data) {
    const payload = {};

    data?.forEach(elm => {
      const componentType = elm?.component?.sType;

      if (elm?.data?.bPayload || elm?.data?.bPayload == 0) {
        payload[elm.component.sName] = elm.data.bPayload;
      }

      if (
        elm.child &&
        componentType !== "DIALOG" &&
        componentType !== "INPUTTABLE" &&
        componentType !== "MULTIRECORD"
      ) {
        Object.assign(payload, mainPayloadData(elm.child));
      }
    });

    return payload;
  }

      function payloadData(data) {
        const payload = {};
        data?.forEach(elm => {
          if (elm?.data?.bPayload || elm?.data?.bPayload == 0) {
            // For DATERANGE/DATETIMERANGE with custom field names, register those instead of sName
            const cType = elm?.component?.sType;
            if ((cType === "DATERANGE" || cType === "DATETIMERANGE") && elm?.data?.bPayload == 1) {
              if (elm?.data?.sStartValueFieldName) {
                payload[elm.data.sStartValueFieldName] = 1;
              }
              if (elm?.data?.sEndValueFieldName) {
                payload[elm.data.sEndValueFieldName] = 1;
              }
              if (elm?.data?.sStartTimeFieldName) {
                payload[elm.data.sStartTimeFieldName] = 1;
              }
              if (elm?.data?.sEndTimeFieldName) {
                payload[elm.data.sEndTimeFieldName] = 1;
              }
            } else {
              payload[elm.component.sName] = elm?.data?.bPayload;
            }
          }
          if (elm?.inputType?.data?.bPayload || elm?.inputType?.data?.bPayload == 0) {
            payload[elm?.inputType?.component?.sName] = elm?.inputType?.data?.bPayload;
          }
          if (elm.child) {
            // alert(JSON.stringify(elm.component.sType));
            if (elm.component.sType != "DIALOG") {
              Object.assign(payload, payloadData(elm.child));
            }
          }
          if (elm.fixcolumns) {
            // alert(JSON.stringify(elm.component.sType));
            if (elm.component.sType != "DIALOG") {
              Object.assign(payload, payloadData(elm.fixcolumns));
            }
          }
        });
        if(conversionNamesMapping){
          const conversions = Object.values(conversionNamesMapping);
          if(conversions && conversions.length > 0){
            conversions.forEach((value) => payload[value] = 1);
          }
        }
        return payload;
      }

      const nextPayloads = payloadData(formData?.details);
      const nextMainPayloads = mainPayloadData(formData?.details);

  setMainPayloads(prev => {
    const isSame =
      JSON.stringify(prev || {}) === JSON.stringify(nextMainPayloads || {});

    return isSame ? prev : nextMainPayloads;
  });

      setbPayloads(prev => {
        const isSame =
          JSON.stringify(prev || {}) === JSON.stringify(nextPayloads || {});

        return isSame ? prev : nextPayloads;
      });

      // console.log('TextField2',validationData( formData?.details));

      /* eslint-enable no-fallthrough */
      if (handleModalclick) {
        // alert(JSON.stringify(textValue))
        setValidationRules(dialogformvalidate);
        setformMetata(dialogform);

        if (modalActionTypeAndID.type !== "delete") {
          // alert
          // aler
          const matchingFields = findMatchingFields(dialogform, modalEditData);
          // if (!isOpenModalChildData) {
          // }
          if(modalEditData?.sUserCode && Object.keys(modalEditData?.sUserCode).length > 0){
            const empCode = modalEditData?.sUserCode?.sEmployeeCode;
            matchingFields.sUserCode = empCode;
          }
          if(modalEditData?.sRoles && Object.keys(modalEditData?.sRoles).length > 0){
            const roleCode = modalEditData?.sRoles?.sRoleID;
            matchingFields.sRoles = roleCode;
          }
          setTextValue(prev => mergeDialogFieldsPreservingResolvedValues(prev, matchingFields));
          setVarValue(prev => mergeDialogFieldsPreservingResolvedValues(prev, matchingFields));

          // alert(JSON.stringify( data?.component.sFormAction));
        } else {
          setTextValue(dialogform);
        }
      } else {
          const nextValidationRules = validationData(formData?.details);

          setValidationRules(prev => {
            const isSame =
              JSON.stringify(prev || {}) === JSON.stringify(nextValidationRules || {});

            return isSame ? prev : nextValidationRules;
          });
      }
    }, [formData, openModalChildData, urlCapture, isSubmited, modalEditData, handleModalclick]);

    const [summerydata, setSummerydata] = useState();

    useEffect(() => {
      const summaryObj = summaryfields || {};
      const summaryArr = Object.entries(summaryObj)?.map(([key, value]) => {
        if (key === "summ_handling") {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: summaryObj?.handlettotal?.summ_handleTotal
          };
        } else if (key === "summ_shipping") {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: summaryObj?.handlettotal?.summ_shipTotal
          };
        } else if (key === "disc_type") {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: summaryObj?.handlettotal?.disc_type
          };
        } else if (key === "summ_discount") {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: summaryObj?.handlettotal?.summ_discountTotal
          };
        } else if (key === "summ_adjustment") {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: summaryObj?.handlettotal?.summ_adjustmentTotal
          };
        } else if (key === "summ_tax") {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: summaryObj?.handlettotal?.summ_taxTotal
          };
        } else {
          return {
            sSummaryID: key,
            sInputValue: value,
            sValue: ""
          };
        }
      });

      // console.log(summaryArr, "summaryArr");
      // console.log(tableMianData, "tableMianData");
      const resultArr = [];
      tableMianData?.length > 0 &&
        tableMianData?.map((tableObj, index) => {
          summaryArr?.map((summaryObj, ind) => {
            if (tableObj.sSummaryID === summaryObj.sSummaryID) {
              if (summaryObj?.sValue) {
                if (
                  tableObj?.sFieldInput === "TEXTFIELD" ||
                  tableObj?.sFieldInput === "SELECT" ||
                  tableObj?.sField === "NUMBER" ||
                  tableObj?.sField === "VARSELECT"
                ) {
                  resultArr.push({
                    sSummaryID: tableObj.sSummaryID,
                    sInputValue: summaryObj.sInputValue,
                    sValue: summaryObj?.sValue
                  });
                } else {
                  resultArr.push({
                    sSummaryID: tableObj.sSummaryID,
                    sInputValue: "",
                    sValue: summaryObj.sInputValue
                  });
                }
              } else {
                if (tableObj?.sFieldInput === "TEXTFIELD" || tableObj?.sFieldInput === "SELECT") {
                  resultArr.push({
                    sSummaryID: tableObj.sSummaryID,
                    sInputValue: summaryObj.sInputValue,
                    sValue: ""
                  });
                } else {
                  resultArr.push({
                    sSummaryID: tableObj.sSummaryID,
                    sInputValue: "",
                    sValue: summaryObj.sInputValue
                  });
                }
                // resultArr.push({
                //   sSummaryID: tableObj.sSummaryID,
                //   sInputValue: summaryObj.sInputValue,
                // });
              }
            }
          });
        });

      let value = [];
      resultArr?.map(item => {
        value.push(item);
      });

      value.push({
        sSummaryID: "disc_type",
        sInputValue: summaryObj.disc_type
      });

      setSummerydata(value);
    }, [summaryfields, urlCapture, isSubmited]);

    // eslint-disable-next-line
    const handleCancel = (destination, nextaction) => {
      navigate(destination);
    };
    // eslint-disable-next-line
    const handleNext = (destination, nextaction) => {
      navigate(nextaction);
    };

    function hasInputTable(data) {
      if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          if (hasInputTable(data[i])) {
            return true;
          }
        }
      } else if (typeof data === "object" && data !== null) {
        if (data.hasOwnProperty("sType") && data.sType === "INPUTTABLE") {
          return true;
        } else {
          // Recursively check nested objects
          for (const key in data) {
            if (hasInputTable(data[key])) {
              return true;
            }
          }
        }
      }
      return false;
    }

    useEffect(() => {
      // Example usage with an 8-level nested array
      const nestedArray = formData; /* Your 8-level nested array here */
      const hasInputTableResult = hasInputTable(nestedArray);
      if (hasInputTableResult) {
        setIsTable(hasInputTableResult);
      }

      // alert(JSON.stringify(formData && formData?.details))
      [formData]?.map(item => {
        item &&
          item?.details?.map(data => {
            // alert(JSON.stringify( item?.details))
            switch (data?.component?.sType) {
              case "TEXTFIELD":
                // Do something for TEXTFIELD
                break;
              case "COUNTER":
                // Do something for TEXTFIELD
                break;
              case "AUTOCOMPLETE":
                // Do something for AUTOCOMPLETE
                break;
              case "CHECKBOX":
                // Do something for CHECKBOXTEXTFIELD
                break;
              case "PASSWORDTEXTFIELD":
                // Do something for CHECKBOXTEXTFIELD
                break;
              case "FIXVALUE":
                // Do something for CHECKBOXTEXTFIELD
                break;
              case "RADIOGROUP":
                // Do something for RADIOGROUP
                break;
              case "SELECT":
                // Do something for SELECT
                break;
              case "NUMBER":
                // Do something for NUMBER
                break;
              case "VARSELECT":
                // Do something for NUMBER
                break;
              case "DATETIME":
                // Do something for DATETIME
                break;
              case "INPUTTABLE":
                if (data?.component?.options.mode === "DEFAULT") {
                  setDefaultTableMode(data?.component?.options.mode);
                  setDefaultTableName(data?.component.sName);
                }
                if (data?.component?.options.mode === "FREEFORM") {
                  setFreeformTableMode(data?.component?.options.mode);
                  setFreeformTableName(data?.component.sName);
                }
                if (data?.component?.options.mode === "DEBITCREDIT") {
                  setdebitCreditTableMode(data?.component?.options.mode);
                  setdebitCreditTableName(data?.component.sName);
                  // console.log(data?.component?.options.mode,'data?.component?.options.mode');
                }
                // else {
                //   setdebitCreditTableMode(data?.component?.options.mode || "");
                //   setdebitCreditTableName(data?.component.sName || " ");
                // }

                break;
              // default:
              // Do something for unknown sType values
              // break;
            }
          });
      });
    }, [formData, isSubmited, urlCapture]);

    useEffect(() => {
      if (tablesampledata) {
        const tabledata = tablesampledata;
        const filterDefaultData = tabledata?.map(({ ...rest }) => rest);
        setfilterDefault(filterDefaultData);
      }
      if (freeformdata) {
        const tablefreeform = freeformdata;
        const filterFreeformData = tablefreeform?.map(({ ...rest }) => rest);
        setfilterfreeForm(filterFreeformData);
      }
    }, [tablesampledata, freeformdata]);

    function removeObjectsWithZeroColRate(data) {
      if (data) {
        return data?.filter(item => item.col_rate !== "0.00" && item.col_item);
      }
    }

    function validateData(data) {
      // Check each object in the array
      for (const item of data) {
        // Convert col_credit and col_debit to numbers for strict comparison
        const credit = parseFloat(item.col_credit);
        const debit = parseFloat(item.col_debit);

        // console.log(credit,debit,777777788);
        if (isNaN(credit) || isNaN(debit)) {
          return false;
        }
        // Check if both col_credit and col_debit are "0.00"
        if (credit === 0 && debit === 0) {
          return false; // Return false if condition is met
        }
      }

      // If no object with both col_credit and col_debit as "0.00" is found, return true
      return true;
    }

    function filterNonEmptyFields(dataArray) {
      return dataArray.map(table => {
        table.tabledetails = table?.tabledetails?.filter(detail => {
          for (const key in detail) {
            // Exclude bPrimary from the check
            if (
              key !== "bPrimary" &&
              key !== "id" &&
              key !== "bShippingPrimary" &&
              detail[key] !== ""
            ) {
              return true;
            }
          }
          return false;
        });
        return table;
      });
    }
    function removeBlankRow(data) {
      const isBlank = v =>
        v === "" || v === 0 ||
        (typeof v === "string" && v !== "" && !isNaN(Number(v)) && Number(v) === 0);
      return data?.filter(obj => {
        const nonIdValues = Object.keys(obj)
          .filter(key => key !== "id")
          .map(key => obj[key]);
        return nonIdValues.length > 0 && nonIdValues.some(v => !isBlank(v));
      });
    }
    function collectInputDefaults(elements) {
      const defaults = {};
      function collect(els) {
        els?.forEach(el => {
          const sType = el?.component?.sType;
          if (sType === "INPUT") {
            const sName = el?.component?.sName;
            const sDefault = el?.component?.sDefaultValue;
            if (sName && sDefault && !sDefault.includes("[")) {
              defaults[sName] = sDefault;
            } else if (sName && sDefault && sDefault.includes("[")) {
              const resolved = varValue?.[sName];
              if (resolved !== undefined && resolved !== "") defaults[sName] = resolved;
            }
          } else if (sType === "DATETIME") {
            const component = el?.component;
            const sName = component?.sName;
            const sDefault = component?.sDefaultValue;
            const resolvedDefault = sDefault?.includes("[")
              ? varValue?.[sName]
              : sDefault;

            if (sName && resolvedDefault) {
              const formattedDefault = dateformat(
                resolvedDefault,
                component?.sSourceFormat || "YYYY-MM-DD",
                component?.sSendFormat || component?.sSourceFormat || "YYYY-MM-DD"
              );

              if (
                formattedDefault &&
                formattedDefault !== "Invalid date" &&
                formattedDefault !== "Invalid date format pattern"
              ) {
                defaults[sName] = formattedDefault;
              }
            }
          }

          if (Array.isArray(el?.child)) {
            collect(el.child);
          }
        });
      }
      collect(elements);
      return defaults;
    }

    function collectDisplayedDateValues(elements) {
      const displayedDates = {};

      function collect(els) {
        els?.forEach(el => {
          const component = el?.component;

          if (component?.sType === "DATETIME" && component?.sName) {
            const element = document.getElementById(component.sName);
            const input = element?.matches?.("input")
              ? element
              : element?.querySelector?.("input");
            const displayedValue = String(input?.value ?? "")
              .replace(/\u200e/g, "")
              .trim();

            if (displayedValue) {
              const displayFormat =
                component?.options?.others1?.format ||
                component?.sSendFormat ||
                component?.sSourceFormat ||
                "YYYY-MM-DD";
              const formattedValue = dateformat(
                displayedValue,
                displayFormat,
                component?.sSendFormat || component?.sSourceFormat || "YYYY-MM-DD"
              );

              if (
                formattedValue &&
                formattedValue !== "Invalid date" &&
                formattedValue !== "Invalid date format pattern"
              ) {
                displayedDates[component.sName] = formattedValue;
              }
            }
          }

          if (Array.isArray(el?.child)) {
            collect(el.child);
          }
        });
      }

      collect(elements);
      return displayedDates;
    }

    function buildEffectiveTextValue(elements) {
      const effectiveValues = {
        ...collectInputDefaults(elements),
        ...textValue
      };
      const displayedDates = collectDisplayedDateValues(elements);

      Object.entries(displayedDates).forEach(([fieldName, displayedValue]) => {
        const currentValue = effectiveValues[fieldName];

        if (
          currentValue === undefined ||
          currentValue === null ||
          String(currentValue).trim() === ""
        ) {
          effectiveValues[fieldName] = displayedValue;
        }
      });

      return effectiveValues;
    }

    function filterFields(payload, data2) {
      const filteredData = {};
      for (const key in payload) {
        if (payload[key] == 1) {
          filteredData[key] = data2[key];
        }
        if(key == "sAccountTo" && payload[key] == 1 && !data2[key]){
          filteredData[key] = "";
        }
      }
      return filteredData;
    }

    const bPayloadQuantityConversionMap = collectQuantityConversionPayloadMap(
      formData?.details || []
    );

    function filterFieldsWithPayload(data, payload) {
      if (data) {
        const filteredData = JSON.parse(JSON.stringify(data));
        filteredData.forEach(obj => {
          Object.keys(obj).forEach(key => {
            // (key === "sUnitConversion" && payload["dQuantity"] == "1") || (key === "sExpectedUnitConversion" && payload["dExpectedQuantity"] == "1") || 
            if(key === "sAction"){
              // Do Nothing
            } else if ((!payload[key] || payload[key] != "1") && key != "id") {
              const quantityField = Object.keys(payload).find(payloadKey => {
                return (
                  payload[payloadKey] == "1" &&
                  bPayloadQuantityConversionMap?.[payloadKey] === key
                );
              });

              if (!quantityField) {
                delete obj[key];
              }
            }
          });
        });
        return filteredData;
      }
    }

    const handleGet = (destination, nextaction) => {
    const newUrl = buildUrl(baseURL, destination);

    setSubmitPayloadLoading(true);
    setIsResponseArrived(false);

    axios
      .get(newUrl, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(result => {
        setOpenDebugSection(true);
        setDebugSectionAPIData(prev => [
          ...prev,
          {
            type: "form-get",
            api: newUrl,
            payload: null,
            response: result
          }
        ]);

        const status = result?.data?.metadata?.status;
        const msg = result?.data?.metadata?.msg;

        if (status === "OK") {
          CustomAlert("OK", msg);
          setRefreshData(true);

          if (nextaction) {
            navigate(nextaction);
          }
        } else if (status === "ERROR") {
          CustomAlert("error", msg);
        } else if (status === "WARNING") {
          CustomAlert("warning", msg);
        } else if (status === "INFO") {
          CustomAlert("INFO", msg);
        }
      })
      .catch(error => {
        CustomAlert("error", error?.response?.data?.metadata?.msg || "Request failed");
      })
      .finally(() => {
        setSubmitPayloadLoading(false);
        setIsResponseArrived(true);
      });
  };


    // alert(JSON.stringify(freeFormTabbleArrays))
  const handleSubmit = (destination, nextaction) => {
      if (!defaultTablesReady) {
        console.warn("[Form.js] Submit blocked until DEFAULT input-table hydration completes.", {
          form: formData?.form?.sFormName,
          recordKey: urlCapture,
          tables: defaultInputTableNames
        });
        return;
      }

      const effectiveTextValue = buildEffectiveTextValue(formData?.details);

    const metadata =
      formData && formData.form
        ? {
            sFormName: formData.form.id ? formData.form.id : formData.form.sFormName || "",
            sFormAction: formData.form.sFormAction || "",
            sPrimaryKey: formData.form.sPrimaryKey || "",
            sPrimaryTable: formData.form.sPrimaryTable || "",
            sFormType: formData.form.sFormType || "",
            sPrimaryKeyValue: effectiveTextValue[formData.form.sPrimaryKey]
          }
        : {};

    const dataWithoutIds = multiRecordForBackend.map(item => {
      const newItem = { ...item };
      delete newItem.id;
      return newItem;
    });

    let data = {
      metadata: metadata,
      data: {}
    };

    if (dataWithoutIds.length == 0) {
      data.data.mainrecord = { ...filterFields(mainPayloads, effectiveTextValue) };
    }

    if (dataWithoutIds.length > 0) {
      if (uniqueErrors?.length > 0) {
        CustomAlert("error", "Duplicate Items");
        return;
      }
      data.data.multirecord = filterFieldsWithPayload(dataWithoutIds, bPayloads);
    }

    if (filesForBackend.length > 0) {
      data.data.files = filesForBackend;
    }

    if (filterDefault && filterDefault?.length > 0) {
      filterDefault.forEach((row, index) => row.id = index + 1);

      if (!data.data.tablerecords) {
        data.data.tablerecords = [];
      }

      data.data.mainrecord = {
        ...filterFields(mainPayloads, effectiveTextValue),
        ...defaultTableSummaryFeild
      };

      data.data.tablerecords.push({
        sInputTableName: defaultTableNameAndModel.sName || defaultTableName,
        sInputTableMode: defaultTableNameAndModel?.options?.mode || defaultTableMode,
        tablesummary: defaultTableSummaryData,
        tabledetails: filterFieldsWithPayload(filterDefault, bPayloads)
      });
    }

    if (
      debitCreditTableMode === "DEBITCREDIT" &&
      filterFieldsWithPayload(debitCreditTableData, bPayloads).length > 0
    ) {
      if (debitCreditTotalBalanced) {
        CustomAlert("error", "Debit and credit should equal");
        return;
      }

      if (debitCreditTotal?.totalDebit == 0 || debitCreditTotal?.totalCredit == 0) {
        CustomAlert("error", "Zero total, nothing to save");
        return;
      }

      if (!data.data.tablerecords) {
        data.data.tablerecords = [];
      }

      data.data.tablerecords.push({
        sInputTableName: debitCreditTableName,
        sInputTableMode: debitCreditTableMode,
        tabledetails: filterFieldsWithPayload(debitCreditTableData, bPayloads)
      });
    }

    if (freeFormTabbleArrays?.length > 0) {
      if (uniqueErrors?.length > 0) {
        CustomAlert("error", "Duplicate Items");
        return;
      }

      if (!data.data.tablerecords) {
        data.data.tablerecords = [];
      }

      const freeFormClone = JSON.parse(JSON.stringify(freeFormTabbleArrays));

      const filteredFreeForm = openModalFreeFormName?.length > 0
        ? freeFormClone.filter(item => !openModalFreeFormName.includes(item?.sInputTableName))
        : freeFormClone;

      const returnData = filterNonEmptyFields(filteredFreeForm);

      returnData.forEach(item => {
        const tableConfig = findComponentByName(formData?.details, item?.sInputTableName);
        const resetTarget = tableConfig?.component?.resetTable?.sResetOnInvisible;
        const shouldResetTable = resetTarget && !isPhysicallyVisible(resetTarget);

        if (shouldResetTable) {
          item.tabledetails = [];
          return;
        }

        item.tabledetails = filterFieldsWithPayload(removeBlankRow(item?.tabledetails), bPayloads);

        if (item.columnFieldNames?.length > 0) {
          const allowed = new Set(item.columnFieldNames);

          item.columnFieldNames.forEach(fieldName => {
            const conversionField = bPayloadQuantityConversionMap?.[fieldName];
            if (conversionField) {
              allowed.add(conversionField);
            }
          });

          item.tabledetails = item.tabledetails.map(row => {
            const cleanRow = {};
            if ("id" in row) cleanRow.id = row.id;
            if ("sAction" in row) cleanRow.sAction = row.sAction;

            allowed.forEach(key => {
              if (key in row) cleanRow[key] = row[key];
            });

            return cleanRow;
          });
        }

        const editRecord = freeFormTabbleEditArrays?.find(
          edit => edit.sInputTableName === item.sInputTableName
        );

        if (editRecord?.tabledetails) {
          item.tabledetails.forEach(row => {
            const editRow = editRecord.tabledetails.find(er => er.id === row.id);

            if (editRow) {
              Object.keys(editRow).forEach(key => {
                if ((key in row) && bPayloads[key] && bPayloads[key] == "1") {
                  row[key] = editRow[key];
                }
              });
            }
          });
        }
      });

      returnData.map(item => {
        if (item.sInputTableMode === "FREEFORM") {
          const { sType, columnFieldNames, ...cleanItem } = item;
          return data.data.tablerecords.push(cleanItem);
        }
      });
    }

    if (
      freeFormTabbleArrays?.length > 0 &&
      data?.data?.tablerecords?.[0]?.sInputTableMode == "FREEFORM"
    ) {
      data?.data?.tablerecords?.forEach(record => {
        if (record.sInputTableName == freeFormDataSubmit?.table) {
          record.tabledetails.forEach((item, index) => {
            if (!item?.id && freeFormDataSubmit?.data?.[index]?.["id"]) {
              item["id"] = freeFormDataSubmit?.data[index]?.["id"];
            }

            for (const [key, value] of Object.entries(bPayloads)) {
              if (value && (key in item) && freeFormDataSubmit?.data?.[index]?.[key]) {
                item[key] = freeFormDataSubmit?.data?.[index]?.[key];
              }
            }
          });
        }
      });
    }

    if (singlefileImg && singlefileImg !== undefined) {
      const uploadFormData = new FormData();
      uploadFormData.append("file", singlefileImg);

      axios
        .post(`${serverAddress}${imageuploadURL}`, uploadFormData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          SettingInitialValues();
        })
        .catch(() => {
          CustomAlert("error", "Something Went Wrong");
        });
    }

    if (Object.keys(multiplefileImg)?.length > 0) {
      for (let i = 0; i < multiplefileImg?.length; i++) {
        if (multiplefileImg[i] !== undefined) {
          const uploadFormData = new FormData();
          uploadFormData.append("file", multiplefileImg[i]);
          setIsResponseArrived(false);

          axios
            .post(`${serverAddress}${imageuploadURL}`, uploadFormData, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            })
            .then(response => {
              SettingInitialValues();
            })
            .catch(() => {
              CustomAlert("error", "Something Went Wrong");
            })
            .finally(() => {
              setIsResponseArrived(true);
            });
        }
      }
    }

    const uri = baseURL + destination;

    let newUrl = "";
    if (destination.startsWith("/")) {
      newUrl = baseURL + destination;
    } else {
      newUrl = baseURL + "/" + destination;
    }

    if (data?.data?.mainrecord?.dLimit === "") {
      data.data.mainrecord.dLimit = "0.00";
    }

    if (Array.isArray(freeFormTabbleArrays) && freeFormTabbleArrays.length > 0) {
      if (
        data &&
        data.data &&
        Array.isArray(data.data.tablerecords) &&
        data.data.tablerecords.length > 0 &&
        data.data.tablerecords[0].sInputTableMode === "FREEFORM"
      ) {
        if (sectionComponentDataAware && typeof sectionComponentDataAware === "object") {
          const componentDataAwareKey = Object.keys(sectionComponentDataAware)?.[0];

          if (
            componentDataAwareKey &&
            effectiveTextValue[componentDataAwareKey] &&
            effectiveTextValue[componentDataAwareKey] === "No"
          ) {
            for (let record of data.data.tablerecords) {
              if (record.sInputTableName == sectionComponentDataAware[componentDataAwareKey]) {
                record.tabledetails = [];
              }
            }
          }
        }
      }
    }

    if (currencyOptions?.length > 0 && !selectedCurrency) {
      CustomAlert("error", "Please select currency before saving.");
      return;
    }

    setSubmitPayloadLoading(true);
    setIsResponseArrived(false);

    axios
      .post(newUrl, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(result => {
        if (result.data) {
          if (result.data.metadata.status == "OK") {
            setIssubmited(true);
            CustomAlert("OK", result?.data?.metadata?.msg, {
              domain: "transaction",
              action: "save",
              correlationId:
                result?.headers?.["x-correlation-id"] ||
                result?.data?.metadata?.correlationId ||
                result?.data?.metadata?.requestId
            });
            setOpenDebugSection(true);
            setDebugSectionAPIData(prev => [
              ...prev,
              { type: "form", api: newUrl, payload: data, response: result }
            ]);
            // Clear record-owned state before changing routes. Calling
            // SettingInitialValues here used the old form definition and could
            // repopulate the next Add form with the record that was just saved.
            setTextValue({});
            setVarValue({});
            setInitialEditData();
            setfilterDefault([]);
            setfilterfreeForm(undefined);
            setFreeFormTabbleArrays([]);
            setFreeFormInitState([]);
            setDefaultTableSummaryData([]);
            // Do not let the new route mount against the previous route's
            // definition (for example Edit TEXTFIELD sDocNumber before the
            // Add COUNTER definition arrives).
            setFormData("");
            setFreeFormToDefault(true);
            setFreeFromTableRowDataStore([]);
            sethandleModalclick(false);
            setBodycontent([]);
            SetTabledata("");
            setError(null);
            setsummaryfields("");
            setFreeformfield("");
            setDefaultTableMode("");
            setDefaultTableName("");
            setFreeformTableMode("");
            setFreeformTableName("");
            setDefaultTableSelectedLocation("");
            setDefaultTableSelectedDataAwareData({});
            setDefaultTableSelectedSupplier("");
            setSingleImg();
            setmultiplefileImg({});
            setImgUploadURL("");
            setDialogMode();
            setOpen(false);
            setSectionComponentDataAware();
            setConversionNamesMapping({});
            setFreeFormTabbleEditMainrecord([]);
            setFilesForBackend([]);
            setOverLaySplit(false);
            setDialogDrawerOpen(false);
            setRefreshData(true);
            navigate(nextaction);
          } else if (result.data.metadata.status == "ERROR") {
            CustomAlert("error", result?.data?.metadata?.msg);
          } else if (result.data.metadata.status == "WARNING") {
            CustomAlert("warning", result?.data?.metadata?.msg);
          } else if (result.data.metadata.status == "INFO") {
            CustomAlert("INFO", result?.data?.metadata?.msg);
          }
        }
      })
      .catch(error => {
        if (error?.response?.data?.metadata?.status == "ERROR") {
          try {
            let innerMsg =
              error.response?.data?.metadata?.msg?.split("400 : ")?.[1]?.slice(1, -1) || "";

            if (innerMsg) {
              let msg = JSON.parse(innerMsg)?.metadata?.msg;
              CustomAlert("error", msg);
            } else {
              CustomAlert("error", error?.response?.data?.metadata?.msg);
            }
          } catch (error) {
            CustomAlert("error", error?.response?.data?.metadata?.msg);
          }
        } else if (error?.response?.data?.metadata?.status == "WARNING") {
          CustomAlert("warning", error?.response?.data?.metadata?.msg);
        } else if (error?.response?.data?.metadata?.status == "INFO") {
          CustomAlert("INFO", error?.response?.data?.metadata?.msg);
        }
      })
      .finally(() => {
        setSubmitPayloadLoading(false);
        setIsResponseArrived(true);
        setOpen(false);
      });
  };

  const handleDialogGet = (destination, nextaction) => {
    const newUrl = buildUrl(serverAddress, destination);

    setIsResponseArrived(false);

    axios
      .get(newUrl, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setOpenDebugSection(true);
        setDebugSectionAPIData(prev => [
          ...prev,
          {
            type: "dialog-get",
            api: newUrl,
            payload: null,
            response
          }
        ]);

        const status = response?.data?.metadata?.status;
        const msg = response?.data?.metadata?.msg;

        if (status === "OK") {
          CustomAlert("OK", msg);

          if (Object.keys(fetchDataHandleDataGrid || {}).length > 0) {
            fetchDataHandleDataGrid?.fetchDataHandleDataGrid(fetchDataHandleDataGrid.uri);
          }

          if (!isOpenModalChildData && nextaction) {
            navigate(nextaction);
          }

          setRefreshData(true);
        } else if (status === "ERROR") {
          CustomAlert("error", msg);
        } else if (status === "WARNING") {
          CustomAlert("warning", msg);
        } else if (status === "INFO") {
          CustomAlert("INFO", msg);
        }
      })
      .catch(error => {
        CustomAlert("error", error?.response?.data?.metadata?.msg || "Request failed");
      })
      .finally(() => {
        setDataGridModalOpen(false);
        setIsResponseArrived(true);
        setRefreshData(true);
        handleClose();
      });
  };

    const resolveDialogDocumentValue = ({
      dialogData,
      modalData,
      primaryKeyName
    }) => {
      const dialogPrimaryKey =
        dialogData?.component?.sPrimaryKey ||
        dialogData?.sPrimaryKey ||
        primaryKeyName ||
        formData?.form?.sPrimaryKey;

      if (!dialogPrimaryKey) {
        return null;
      }

      return (
        // DATAGRID dialog
        modalData?.row?.[dialogPrimaryKey] ??

        // Alternative DATAGRID structures
        modalData?.PrimaryKeyValue ??
        modalData?.primaryKeyValue ??
        modalData?.[dialogPrimaryKey] ??

        // Menu-route VIEW/EDIT dialog
        textValue?.[dialogPrimaryKey] ??
        varValue?.[dialogPrimaryKey] ??
        initialEditData?.[dialogPrimaryKey] ??
        freeFormTabbleEditMainrecord?.[dialogPrimaryKey] ??

        null
      );
    };

    const resolveDialogDestination = (
      destination,
      documentValue
    ) => {
      if (!destination) {
        throw new Error("Dialog API destination is missing.");
      }

      if (
        documentValue === undefined ||
        documentValue === null ||
        String(documentValue).trim() === ""
      ) {
        throw new Error("Dialog primary-key value is missing.");
      }

      const rawDocumentValue = String(documentValue).trim();
      const encodedDocumentValue = encodeURIComponent(rawDocumentValue);

      let resolvedDestination = String(destination).trim();

      const containsPlaceholder =
        resolvedDestination.includes("[doc]") ||
        resolvedDestination.includes("{doc}");

      if (containsPlaceholder) {
        resolvedDestination = resolvedDestination
          .replaceAll("[doc]", encodedDocumentValue)
          .replaceAll("{doc}", encodedDocumentValue);
      } else {
        /*
        * The destination may already have been resolved upstream,
        * particularly by renderButtonComponent for menu dialogs.
        *
        * Only append the document number when it is not already
        * the final URL segment.
        */
        const destinationWithoutTrailingSlash =
          resolvedDestination.replace(/\/+$/, "");

        const urlSegments =
          destinationWithoutTrailingSlash.split("/");

        const lastSegment =
          urlSegments[urlSegments.length - 1] || "";

        let decodedLastSegment = lastSegment;

        try {
          decodedLastSegment = decodeURIComponent(lastSegment);
        } catch (error) {
          decodedLastSegment = lastSegment;
        }

        const documentAlreadyPresent =
          lastSegment === encodedDocumentValue ||
          decodedLastSegment === rawDocumentValue;

        if (documentAlreadyPresent) {
          resolvedDestination = destinationWithoutTrailingSlash;
        } else {
          resolvedDestination =
            `${destinationWithoutTrailingSlash}/${encodedDocumentValue}`;
        }
      }

      if (
        resolvedDestination.includes("[doc]") ||
        resolvedDestination.includes("{doc}") ||
        resolvedDestination.includes("undefined") ||
        resolvedDestination.includes("null")
      ) {
        throw new Error(
          `Dialog API contains an unresolved value: ${resolvedDestination}`
        );
      }

      return resolvedDestination;
    };

    // console.log(formData?.details, 3344553);
    const handlemodaldata = async (
      destination,
      action,
      dialogData
    ) => {
      let requestWasSent = false;

      try {
        const dialogPrimaryKey =
          dialogData?.component?.sPrimaryKey ||
          dialogData?.sPrimaryKey ||
          openModalDataActive?.sPrimaryKey ||
          modalPrimaryKey ||
          formData?.form?.sPrimaryKey;

        const documentValue = resolveDialogDocumentValue({
          dialogData,
          modalData: modalActionTypeAndID,
          primaryKeyName: dialogPrimaryKey
        });

        const resolvedDestination = resolveDialogDestination(
          destination,
          documentValue
        );

        const uri = buildUrl(baseURL, resolvedDestination);

        console.log("[Form.js] Dialog transaction request", {
          action,
          destination,
          dialogPrimaryKey,
          documentValue,
          resolvedDestination,
          uri,
          modalActionTypeAndID,
          textValue,
          openModalDataActive
        });

        setIsResponseArrived(false);
        setSubmitPayloadLoading(true);

        let response;

        if (action === "DELETE") {
          requestWasSent = true;
          response = await axios.delete(uri, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
        } else if (action === "TXCANCEL") {
          /*
          * Retain the HTTP method expected by your backend.
          *
          * Your current implementation uses POST.
          */
          requestWasSent = true;
          response = await axios.post(
            uri,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          );
        } else {
          throw new Error(
            `Unsupported dialog transaction action: ${action || "undefined"}`
          );
        }

        const status = response?.data?.metadata?.status;
        const message = response?.data?.metadata?.msg;

        if (status === "ERROR") {
          CustomAlert("error", message || "Transaction failed.");
          return;
        }

        if (status === "WARNING") {
          CustomAlert("warning", message);
          return;
        }

        if (status === "INFO") {
          CustomAlert("INFO", message);
          return;
        }

        CustomAlert("OK", message || "Transaction completed successfully.", {
          domain: "transaction",
          action: action || "complete",
          correlationId:
            response?.headers?.["x-correlation-id"] ||
            response?.data?.metadata?.correlationId ||
            response?.data?.metadata?.requestId
        });

        setOpenDebugSection(true);
        setDebugSectionAPIData(prev => [
          ...prev,
          {
            type: "dialog-transaction",
            action,
            api: uri,
            payload: null,
            response
          }
        ]);

        setRefreshData(true);

        if (
          fetchDataHandleDataGrid?.fetchDataHandleDataGrid &&
          fetchDataHandleDataGrid?.uri
        ) {
          fetchDataHandleDataGrid.fetchDataHandleDataGrid(
            fetchDataHandleDataGrid.uri
          );
        }

        /*
        * In poView, sAction is /form/get/poMain.
        * Navigation can remain controlled by the existing dialog flow,
        * or you can pass nextAction separately.
        */
      } catch (error) {
        console.error("[Form.js] Dialog transaction failed", {
          action,
          destination,
          modalActionTypeAndID,
          textValue,
          openModalDataActive,
          error
        });

        CustomAlert(
          "error",
          error?.response?.data?.metadata?.msg ||
            error?.message ||
            "Unable to process the transaction."
        );
      } finally {
        setSubmitPayloadLoading(false);
        setIsResponseArrived(true);

        // Once a DELETE/TXCANCEL request has completed, the confirmation
        // dialog has served its purpose. Keep the persistent response alert
        // visible on the calling form, regardless of business status.
        if (requestWasSent) {
          handleClose();
        }
      }
    };

    useEffect(() => {
      setFilesForBackend([]);
    }, [route])

    // useEffect(() => {
    //   if (!open) {
    //     // setOpenModalChildData([]);
    //   }
    // }, [open]);

    function getTableName(data) {
      const tableData = {};
      if (data) {
        for (let i = 0; i < data?.length; i++) {
          if (
            data[i]?.component?.sType == "INPUTTABLE" ||
            data[i]?.component?.sType == "MULTIRECORD"
          ) {
            tableData[data[i].component.sName] = data[i].component;
          }
        }
      }
      return tableData;
    }

    function buildUrl(base, destination) {
      if (!destination) return base;

      if (destination.startsWith("http")) {
        return destination;
      }

      if (destination.startsWith("/")) {
        return `${base}${destination}`;
      }

      return `${base}/${destination}`;
    }

    const getValueByPath = (obj, path) => {
      if (!obj || !path) return undefined;

      return String(path)
        .split(".")
        .reduce((acc, key) => {
          if (acc === undefined || acc === null) return undefined;
          return acc[key];
        }, obj);
    };

    function replaceURIParams(data, uri) {
      // Regular expression to match placeholders like {S6-SELECT-004}
      const placeholderRegex = /{([^}]+)}/g;

      // Replace each placeholder in the URI
      const replacedURI = uri.replace(placeholderRegex, (match, placeholder) => {
        // Remove any leading and trailing whitespaces from the placeholder
        placeholder = placeholder.trim();

        // Check if the placeholder exists in the data object
        if (data.hasOwnProperty(placeholder)) {
          // If the placeholder exists, return its corresponding value
          return data[placeholder];
        } else {
          // If the placeholder doesn't exist, return the original placeholder
          return match;
        }
      });

      return replacedURI;
    }
    function checkMultirecorInModal(data) {
      let result = false;
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.component?.sType == "MULTIRECORD") {
          result = true;
        }
      }
      return result;
    }
    // this is for button event handling
    const handleclickdata = (e, mode, uri, data) => {
      // Handle single-argument call: handleClickOpen(mode) from openModalforGroupAdd
      if (e?.options?.handler && mode === undefined) {
        mode = e;
        e = null;
      }

      if (mode?.options?.handler == "handleCancel") {
        setDefaultTableSelectedLocation("");
        setDefaultTableSelectedSupplier("");
        setFilesForBackend([]);
        handleCancel(uri?.sAction);
        handleClose();

        return;
      }

      if (mode?.options?.handler == "handleGet") {
        const effectiveTextValue = {
          ...collectInputDefaults(formData?.details),
          ...textValue
        };

        handleGet(
          replaceURIParams(effectiveTextValue, uri?.sDataDestination),
          replaceURIParams(effectiveTextValue, uri?.sAction)
        );

        return;
      }

      if (mode?.options?.handler == "handleSubmit") {
        // this is for main form submit
        setDefaultTableSelectedLocation("");
        setDefaultTableSelectedSupplier("");
        if (mode?.options.action == "CANCEL") {
          setFilesForBackend([]);
          navigate(uri?.sAction);
          return;
        }
        // alert(JSON.stringify(allowZeroValue))

        const effectiveTextValue = buildEffectiveTextValue(formData?.details);

        const requiredErrors = collectRequiredFieldErrors(
          formData?.details,
          effectiveTextValue
        );

        if (Object.keys(requiredErrors).length > 0) {
          console.log(
            "SUBMIT BLOCKED BY REQUIRED FIELD(S):",
            Object.entries(requiredErrors).map(([sName, message]) => ({
              sName,
              message
            }))
          );

          setError(prev => ({
            ...prev,
            ...requiredErrors
          }));

          return;
        }
        setError(prev => {
          const next = { ...prev };

          Object.keys(requiredErrors).forEach(key => {
            if (!requiredErrors[key]) {
              delete next[key];
            }
          });

          return next;
        });

        const freeformErr = freeFormValidateFunction ? freeFormValidateFunction() : false;
        const multirecordErr = multirecordValidateFunction ? multirecordValidateFunction() : false;
        const debitCreditErr = debitCreditValidateFunction ? debitCreditValidateFunction() : false;
        const defaultTableErr = defaultTableValidateFunction ? defaultTableValidateFunction() : false;

        // alert(Object.keys(openModalDataActive).length == 0 )

        // alert(JSON.stringify(freeformErr));
        // const errors = globalvalidateTextField(textValue, validaterules);

        if (freeformErr || multirecordErr || debitCreditErr || defaultTableErr) {
          console.log("SUBMIT BLOCKED BY TABLE VALIDATION", {
            freeformErr,
            multirecordErr,
            debitCreditErr,
            defaultTableErr
          });

          return;
        }
        // alert(JSON.stringify(multirecordExist))
        if (multirecordExist && multiRecordForBackend.length == 0) {
          CustomAlert("error", "No Changes to Save");
          return;
        }
        if (allowZeroValue && filterDefault && filterDefault.length > 0) {
          CustomAlert("error", "Total cannot be zero value");
          return;
        }

        handleSubmit(
          replaceURIParams(effectiveTextValue, uri?.sDataDestination),
          replaceURIParams(effectiveTextValue, uri?.sAction)
        );
        // fetchDataHandleDataGrid?.fetchDataHandleDataGrid(fetchDataHandleDataGrid.uri);
        return;
      }
      if (mode?.options?.handler == "handleEdit") {
        // alert("handleEdit");
        return;
      }
      if (mode?.options?.handler == "handleView") {
        // alert("handleView");
        return;
      }
      if (mode?.options?.handler == "handleNext") {
        handleNext(uri?.sDataSource, uri?.sAction, uri);
        return;
      }

      if (mode?.options?.handler == "handleDialogGet") {
        const dialogEffectiveTextValue = {
          ...collectInputDefaults(openModalChildData),
          ...textValue
        };

        handleDialogGet(
          replaceURIParams(dialogEffectiveTextValue, uri?.sDataDestination),
          replaceURIParams(dialogEffectiveTextValue, uri?.sAction)
        );

        return;
      }

      if (mode?.options?.handler === "handleDialogFormSubmit") {
        const dialogAction = mode?.options?.action;

        /*
        * DELETE and TXCANCEL can be called from:
        *
        * 1. DATAGRID dialogs
        * 2. Menu-route dialogs such as poView
        *
        * Do not depend only on modalActionTypeAndID.type because
        * menu-route dialogs may not populate that DATAGRID state.
        */
        if (
          dialogAction === "DELETE" ||
          dialogAction === "TXCANCEL"
        ) {
          handlemodaldata(
            uri?.sDataDestination,
            dialogAction,
            openModalDataActive
          );

          return;
        }

        // Existing normal dialog form submission continues below...
        // this is for form submission of dialog data
        const dataWithoutIds = multiRecordForBackend.map(item => {
          const newItem = { ...item };
          delete newItem.id;
          return newItem;
        });
        const errors = globalvalidateTextField(textValue, validaterules);

        if (Object.keys(errors)?.length > 0) {
          setError(prevError => ({
            ...prevError,
            ...errors
          }));
          return;
        }

        const dialogDesiredObject = formData?.details?.find(obj => obj.component.sPrimaryKey);
        const dialogPrimaryKey = openModalDataActive.sPrimaryKey || dialogDesiredObject?.component?.sPrimaryKey;
        const dialogEffectiveTextValue = { ...collectInputDefaults(openModalChildData), ...textValue };
        const dialogValueSources = [
          dialogTextValue,
          modalActionTypeAndID?.row,
          modalEditData,
          initialEditData,
          freeFormTabbleEditMainrecord
        ];

        Object.keys(dialogKeyMapping || {}).forEach(fieldName => {
          if (!isUnresolvedDialogTemplateValue(dialogEffectiveTextValue[fieldName])) {
            return;
          }

          const resolvedValue = dialogValueSources
            .map(source => source?.[fieldName])
            .find(value =>
              value !== undefined &&
              value !== null &&
              String(value).trim() !== "" &&
              !isUnresolvedDialogTemplateValue(value)
            );

          if (resolvedValue !== undefined) {
            dialogEffectiveTextValue[fieldName] = resolvedValue;
          }
        });

        const unresolvedDialogField = Object.keys(dialogKeyMapping || {}).find(
          fieldName => isUnresolvedDialogTemplateValue(dialogEffectiveTextValue[fieldName])
        );

        if (unresolvedDialogField) {
          CustomAlert("error", `Unable to submit because ${unresolvedDialogField} is unresolved.`);
          return;
        }

        const resolvedDialogDestination = replaceURIParams(
          dialogEffectiveTextValue,
          uri?.sDataDestination || ""
        );

        if (/{[^}]+}|\[[^\]]+\]/.test(resolvedDialogDestination)) {
          CustomAlert("error", "Unable to submit because the dialog destination contains an unresolved value.");
          return;
        }

        let data2 = {
          metadata: {
            sPrimaryTable: openModalDataActive.sPrimaryTable,
            sPrimaryKey: dialogPrimaryKey,
            sPrimaryKeyValue: dialogEffectiveTextValue[dialogPrimaryKey],
            sFormName: openModalDataActive.sFormName,
            sFormAction: openModalDataActive.sFormAction,
            sFormType: openModalDataActive.sFormType
          },
          data: {}
        };
        // alert(JSON.stringify(openModalChildData));
        if (dataWithoutIds.length == 0) {
          // alert(JSON.stringify( bPayloadsDailog))
          // alert(JSON.stringify(textValue));
          data2.data.mainrecord = filterFields(bPayloadsDailog, dialogEffectiveTextValue);
        }
        // alert(JSON.stringify(bPayloadsDailog))
        for (const key in getTableName(openModalChildData)) {
          for (let i = 0; i < openModalChildData.length; i++) {
            if (openModalChildData[i].component.sName == key) {
              if (openModalChildData[i].component.sType == "MULTIRECORD") {
                data2.data.multirecord = filterFieldsWithPayload(dataWithoutIds, bPayloadsDailog);
                const multirecordErr = multirecordValidateFunction
                  ? multirecordValidateFunction()
                  : false;
                if (multirecordErr) {
                  return;
                }
              }
              if (
                openModalChildData[i].component.sType == "INPUTTABLE" &&
                openModalChildData[i].component.options.mode == "FREEFORM"
              ) {
                data2.data.tablerecord = {
                  sInputTableName: openModalChildData[i].component.sName,
                  sInputTableMode: openModalChildData[i].component.options.mode,
                  tabledetails: [filterFieldsWithPayload(filterFreeform, bPayloadsDailog)]
                };
                const freeformErr = freeFormValidateFunction ? freeFormValidateFunction() : false;
                if (freeformErr) {
                  return;
                }
              }
              if (
                openModalChildData[i].component.sType == "INPUTTABLE" &&
                openModalChildData[i].component.options.mode == "DEFAULT"
              ) {
                data2.data.tablerecord = {
                  sInputTableName: openModalChildData[i].component.sName,
                  sInputTableMode: openModalChildData[i].component.options.mode,
                  tabledetails: [filterFieldsWithPayload(filterDefault, bPayloadsDailog)]
                };
                const defaultTableErr = defaultTableValidateFunction
                  ? defaultTableValidateFunction()
                  : false;
                if (defaultTableErr) {
                  return;
                }
              }
              if (
                openModalChildData[i].component.sType == "INPUTTABLE" &&
                openModalChildData[i].component.options.mode == "DEBITCREDIT"
              ) {
                data2.data.tablerecord = {
                  sInputTableName: openModalChildData[i].component.sName,
                  sInputTableMode: openModalChildData[i].component.options.mode,
                  tabledetails: [filterFieldsWithPayload(debitCreditTableData, bPayloadsDailog)]
                };
                // const debitCreditErr = debitCreditValidateFunction
                //   ? debitCreditValidateFunction()
                //   : false;
                // if (debitCreditErr) {
                //   return;
                // }
              }
            }
          }
        }

        // alert(JSON.stringify(checkMultirecorInModal (openModalChildData)) );
        if (
          checkMultirecorInModal(openModalChildData) &&
          multirecordExist &&
          multiRecordForBackend.length == 0
        ) {
          CustomAlert("error", "No Changes to Save");
          return;
        }
        if (filesForBackend.length > 0) {
          data2.data.files = filesForBackend;
        }
        const filteredMultirecord = data2?.data?.multirecord?.filter((record) => {
          const hasUnitFields = !record.sUnitAbbrev && !record.sUnitDescription && record.sUnitCode === "AUTOGENERATE";
          const hasDimensionFields = !record.sDimensionAbbrev && !record.sDimensionDescription && record.sDimensionCode === "AUTOGENERATE";
          const hasWeightFields = !record.sWeightAbbrev && !record.sWeightDescription && record.sWeightCode === "AUTOGENERATE";
          return !(hasUnitFields || hasDimensionFields || hasWeightFields);
        });

        const apiData = JSON.parse(JSON.stringify(data2));
        
        if(apiData?.data?.multirecord){
          apiData.data.multirecord = filteredMultirecord;
        }
        setIsResponseArrived(false);

        if(apiData?.metadata?.sFormAction == "PRINT"){

          fetch(`${serverAddress}${resolvedDialogDestination}`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(apiData)
          })
          .then(async (response) => {
            try {
              const blob = await response.blob();
              const objectURL = URL.createObjectURL(blob);
              const windowFeatures = 'width=1300,height=700,left=100,top=100';
              window.open(objectURL, '_blank', windowFeatures);
            } catch (error) {
              console.log(error);
            }
            setDefaultTableSelectedDataAwareData({})
            setOpenDebugSection(true);
            setDebugSectionAPIData((prev) => [...prev, {"type": "dialog", "api": `${serverAddress}${resolvedDialogDestination}`, "payload": apiData, "response": response}])
            setformIsSubmited((prev) => !prev);
            setMultiRecordForBackend([])
            if (selectAndAutocompleteSname) {
              setTimeout(() => {
                setTextValue(preValue => {
                  return {
                    ...preValue,
                    [selectAndAutocompleteSname.name]:
                      response?.data.data.mainrecord?.[selectAndAutocompleteSname.value]
                  };
                });
                setSelectAndAutocompleteSname("");
              }, 350);
            }
            CustomAlert("OK", response?.data?.metadata?.msg);
            handleClose();
            // alert(fetchDataHandleDataGrid.uri)
            // }, 1000);
            // console.log("File uploaded successfully:", response.data);
            if (Object.keys(fetchDataHandleDataGrid).length > 0) {
              fetchDataHandleDataGrid?.fetchDataHandleDataGrid(fetchDataHandleDataGrid.uri);
            }
            if (!isOpenModalChildData) {
              if (uri.sAction && formData?.form?.sFormAction !== "EDIT") {
                navigate(uri.sAction);
              }
              // SettingInitialValues();
            }
            setOverLaySplit(false);

            if (selectAndAutocompleteSname) {
              setTextValue(preValue => {
                return {
                  ...preValue,
                  [selectAndAutocompleteSname.name]:
                    response?.data.data.mainrecord?.[selectAndAutocompleteSname.value]
                };
              });
              setSelectAndAutocompleteSname("");
            }
          }).catch((error) => {
            console.log(error);
          }).finally(() => {
            (setIsResponseArrived)(true);
          });
          return;
        }

        const action = formData?.details?.[0]?.child?.[0]?.component?.previewSection?.data?.sAction || "";
        if(action == "PDF"){
          fetch(`${serverAddress}${resolvedDialogDestination}`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(apiData)
          })
          .then(async (response) => {
            try {
              const blob = await response.blob();
              const objectURL = URL.createObjectURL(blob);
              setReportData(objectURL);
              setIsOpenModalChildData(false);
              setNestedDialog(false);
              setOpen(false);
            } catch (error) {
              console.log(error);
            }
          }).catch((error) => {
            console.log(error);
          }).finally(() => {
            setIsResponseArrived(true);
          });
          return;
        }
        if (openModalDataActive.sFormType === "FIELDVALUEENTRY") {
          if (bulkActionLoader && !bulkData?.progressEnabled) {
            setShowBulkActionLoading(true);
          }
          const allFieldValues = filterFields(bPayloadsDailog, textValue);
          const fieldValues = Object.fromEntries(
            Object.entries(allFieldValues).filter(([, v]) => v !== "" && v !== null && v !== undefined)
          );
          setIsResponseArrived(false);
          axios
            .post(`${serverAddress}${resolvedDialogDestination}`, fieldValues, {
              headers: {
                Authorization: `Bearer ${token}`,
                ...(bulkData?.operationId
                  ? { "X-Bulk-Operation-Id": bulkData.operationId }
                  : {})
              }
            })
            .then(async (response) => {
              setDefaultTableSelectedDataAwareData({});
              setOpenDebugSection(true);
              setDebugSectionAPIData((prev) => [...prev, {"type": "dialog", "api": `${serverAddress}${resolvedDialogDestination}`, "payload": fieldValues, "response": response}]);
              setformIsSubmited((prev) => !prev);
              setMultiRecordForBackend([]);
              CustomAlert(
                response?.data?.metadata?.status === "PARTIAL" ? "warning" : "OK",
                formatBulkOperationMessage(response?.data)
              );
              handleClose();
              if (!isOpenModalChildData) {
                if (uri.sAction && formData?.form?.sFormAction !== "EDIT") {
                  navigate(uri.sAction);
                }
              }
              setOverLaySplit(false);
            })
            .catch(error => {
              CustomAlert(
                "error",
                formatBulkOperationMessage(error?.response?.data) || error?.message || "Bulk operation failed"
              );
            })
            .finally(() => {
              setDataGridModalOpen(false);
              setIsResponseArrived(true);
              setRefreshData(true);
              handleClose();
              setShowBulkActionLoading(false);
              setBulkActionLoader(false);
            });
          return;
        }

        if(bulkActionLoader && !bulkData?.progressEnabled){
          setShowBulkActionLoading(true);
        }

        axios
          .post(`${serverAddress}${resolvedDialogDestination}`, apiData, {
            headers: {
              Authorization: `Bearer ${token}`,
              ...(bulkData?.operationId
                ? { "X-Bulk-Operation-Id": bulkData.operationId }
                : {})
            }
          })
          .then(async (response) => {
            // alert(JSON.stringify(selectAndAutocompleteSname))
            setDefaultTableSelectedDataAwareData({})
            setOpenDebugSection(true);
            setDebugSectionAPIData((prev) => [...prev, {"type": "dialog", "api": `${serverAddress}${resolvedDialogDestination}`, "payload": apiData, "response": response}])
            setformIsSubmited((prev) => !prev);
            setMultiRecordForBackend([])
            if (selectAndAutocompleteSname) {
              setTimeout(() => {
                setTextValue(preValue => {
                  // alert(JSON.stringify(response?.data.data.mainrecord[selectAndAutocompleteSname.value]));
                  return {
                    ...preValue,
                    [selectAndAutocompleteSname.name]:
                      response?.data.data.mainrecord?.[selectAndAutocompleteSname.value]
                  };
                });
                setSelectAndAutocompleteSname("");
              }, 350);
            }
            CustomAlert(
              response?.data?.metadata?.status === "PARTIAL" ? "warning" : "OK",
              formatBulkOperationMessage(response?.data)
            );
            handleClose();
            // alert(fetchDataHandleDataGrid.uri)
            // }, 1000);
            // console.log("File uploaded successfully:", response.data);
            if (!isOpenModalChildData) {
              if (uri.sAction && formData?.form?.sFormAction !== "EDIT") {
                navigate(uri.sAction);
              }
              // SettingInitialValues();
            }
            setOverLaySplit(false);

            if (selectAndAutocompleteSname) {
              setTextValue(preValue => {
                return {
                  ...preValue,
                  [selectAndAutocompleteSname.name]:
                    response?.data.data.mainrecord?.[selectAndAutocompleteSname.value]
                };
              });
              setSelectAndAutocompleteSname("");
            }
          })
          .catch(error => {
            CustomAlert(
              "error",
              formatBulkOperationMessage(error?.response?.data) || error?.message || "Bulk operation failed"
            );
          })
          .finally(() => {
            setDataGridModalOpen(false);
            setIsResponseArrived(true);
            setRefreshData(true);
            handleClose();
            setShowBulkActionLoading(false);
            setBulkActionLoader(false);
          });
        // handleNext(uri?.sDataSource, uri?.sAction, uri);
        return;
      }
      if (mode?.options?.handler == "handleDialog") {
        handleClickOpen(mode);
        return;
      }
      if (mode?.options?.handler == "handleClose") {
        handleClose();
        return;
      }
      if (mode?.options?.mode === "LINK") {
        const submode = mode?.options?.submode;
        if (submode === "OPENINFORM") {
          navigate(uri?.sAction);
          return;
        }
        if (submode === "OPENINTAB") {
          window.open(window.location.origin + uri?.sAction, "_blank");
          return;
        }
        if (submode === "URLOPENINFORM") {
          window.location.href = uri?.sAction;
          return;
        }
        if (submode === "URLOPENINTAB") {
          window.open(uri?.sAction, "_blank");
          return;
        }
        if (submode === "JSONOPENINFORM" || submode === "JSONOPENINTAB") {
          const sourceUrl = replaceURIParams(textValue, uri?.sDataSource || "");
          const finalActionUrl = replaceURIParams(textValue, uri?.sAction || "");

          axios
            .get(`${serverAddress}${sourceUrl}`, {
              headers: { Authorization: `Bearer ${token}` }
            })
            .then(async response => {
              const targetUrl = getValueByPath(response?.data, uri?.sDataDestination);
              const terminateSignal = data?.data?.sTerminateSignal;

              if (
                terminateSignal?.bTerminateAllowed === true &&
                terminateSignal?.sSignalMechanism === "SSE:3PT_Message" &&
                terminateSignal?.sSignalID
              ) {
                const resolvedSignalID =
                  getValueByPath(response?.data, terminateSignal.sSignalID) ||
                  terminateSignal.sSignalID;

                if (resolvedSignalID) {
                  window.dispatchEvent(
                    new CustomEvent("BITS_BUTTON_SIGNAL_ID_READY", {
                      detail: {
                        buttonName: data?.component?.sName,
                        signalID: resolvedSignalID
                      }
                    })
                  );
                }
              }

              if (!targetUrl) {
                console.error("LINK button: no URL found using path", {
                  path: uri?.sDataDestination,
                  response: response?.data
                });
                CustomAlert("error", "Authorization URL not found.");
                return;
              }

              if (submode === "JSONOPENINFORM") {
                window.location.href = targetUrl;
              } else {
                window.open(targetUrl, "_blank");
              }

              if (finalActionUrl) {
                navigate(finalActionUrl);
              }
            })
            .catch(error => {
              console.error("LINK button error:", error);
              CustomAlert("error", error?.response?.data?.metadata?.msg || "Unable to open authorization URL.");
            });

          return;
        }

        return;
      }
      if (mode?.options?.submode === "submit") {
        if (modalActionTypeAndID.type !== "delete") {
          const errors = globalvalidateTextField(textValue, validaterules);
          if (errors) {
            handleClose();
          }
          if (Object.keys(errors)?.length > 0) {
            setError(prevError => ({
              ...prevError,
              ...errors
            }));
            return;
          }
        }

        handlemodaldata(uri?.sDataSource, uri?.sAction);
      }
      if (mode?.options?.submode === "dialogformsubmit") {
        const errors = globalvalidateTextField(textValue, validaterules);

        if (errors) {
          if (Object.keys(errors)?.length > 0) {
            setError(prevError => ({
              ...prevError,
              ...errors
            }));
            return;
          }
        }
        handlemodaldata(uri?.sDataSource, uri?.sAction, mode);
      }
    };

    const handleLinkOpenModal = data => {
      const mode = {
        options: {
          mode: "DEFAULT",
          handler: "handleDialog",
          dialog: data.data.sDataSource
        }
      };
      handleClickOpen(mode);
    };

    useEffect(() => {
      if (urlCapture) {
        SetTabledata("");
        // setTextValue({});
        SettingInitialValues({ preserveExisting: true });
        sethandleModalclick(false);
        setBodycontent([]);
        setError(null);
        setsummaryfields("");
        setFreeformfield("");
        setDefaultTableMode("");
        setDefaultTableName("");
        setFreeformTableMode("");
        setFreeformTableName("");
        // setResultData("");
        setSingleImg();
        setmultiplefileImg({});
        setImgUploadURL("");
        // setmessage("");
        setDialogMode();
        setOpen(false);
      }
    }, [urlCapture]);

    useEffect(() => {
      const isTextValueEmpty = Object.keys(textValue)?.length === 0;
      if (isTextValueEmpty) {
        setIssubmited(false);
      }
    }, [textValue]);

    const handlePointChange = num => {
      if (!num) {
        return "0.00";
      }
      if (num === "Fix") {
        return "Fix";
      }
      if (num === "%") {
        return "%";
      }

      const inputValue = num.toString();
      const userInputLength = inputValue?.length;
      let formattedValue;

      if (inputValue.includes(".")) {
        const arr = inputValue.split(".");
        const newInputValue = inputValue.toString().replace(".", "");
        const lastValue = arr[1];
        const lastValueueLenght = lastValue.toString()?.length;

        if (lastValueueLenght === 2) {
          formattedValue = `${arr[0]}.${lastValue}`;
        } else {
          const STRVAL = newInputValue.toString();
          const arrval = STRVAL.split("");
          const joinVal = arrval.slice(0, -2).join("");

          formattedValue = parseFloat(
            `${parseFloat(joinVal)}.${arrval[arrval?.length - 2]}${arrval[arrval?.length - 1]}`
          );
        }
      } else {
        if (userInputLength > 2) {
          formattedValue = `${inputValue.slice(0, -2)}.${inputValue.slice(-2)}`;
        } else if (userInputLength === 2) {
          formattedValue = `0.${inputValue}`;
        } else if (userInputLength === 1) {
          formattedValue = `0.0${inputValue}`;
        }
      }

      let val = inputValue.includes(".") ? parseFloat(formattedValue) : formattedValue.toFixed(2);

      return isNaN(val) ? "0.00" : val;
    };

    const handleTextValue = (event, ind, validate) => {
      let { name, value } = event.target;
      setIndex(ind);
      if (name === "currency-textend" || name === "currency-text") {
        value = handlePointChange(value);
        setTextValue(textValue => ({ ...textValue, [name]: parseFloat(value).toFixed(2) }));
      } else {
        setTextValue(textValue => ({ ...textValue, [name]: value }));
      }

      let trimmedValue;
      if (name === "currency-textend" || name === "currency-text") {
        trimmedValue = value;
      } else {
        trimmedValue = value?.trim();
      }

      const error = validateTextField(trimmedValue, validate);
      setError(prevError => {
        const newError = { ...prevError, [name]: error };
        return newError;
      });
    };

    const handleTextValue1 = (event, ind, validate) => {
      const { name, value, decimalPlaces } = event.target;
      let formattedValue;
      // alert(decimalPlaces)
      if (decimalPlaces == "0") {
        formattedValue = value;
      } else {
        formattedValue = value.includes(".") ? value : `${value == "" ? 0 : value}.00`;
      }
      // console.log(formattedValue, value, "decimalPlaces7");
      setIndex(ind);
      setTextValue({ ...textValue, [name]: formattedValue });

      const trimmedValue = value?.trim();
      const error = validateTextField(trimmedValue, validate);

      setError(prevError => {
        const newError = { ...prevError, [name]: error };
        return newError;
      });
    };

    const handletabledata = useCallback(e => {
      SetTabledata(e);
      setfilterDefault(Array.isArray(e) ? e.map(row => ({ ...row })) : []);
    }, []);

    const handleDefaultTableHydration = useCallback(snapshot => {
      const tableName = snapshot?.descriptor?.sName;
      if (!tableName || snapshot?.descriptor?.options?.mode !== "DEFAULT") return;

      const payloadRows = Array.isArray(snapshot?.rows)
        ? snapshot.rows.map(row => ({ ...row }))
        : [];

      // Commit the complete DEFAULT-table submission snapshot together. This
      // prevents the action button from observing readiness before Form has
      // received the rows, descriptor, and summary payload.
      SetTabledata(payloadRows);
      setfilterDefault(payloadRows);
      setdefaultTableNameAndModel(snapshot.descriptor);
      setDefaultTableSummaryData(snapshot?.summaryData || []);
      setdefaultTableSummaryFeild(previous => ({
        ...(previous && typeof previous === "object" ? previous : {}),
        ...(snapshot?.summaryField || {})
      }));

      setDefaultTableHydration(previous => {
        const current = previous?.[tableName];
        const next = {
          ready: snapshot?.ready === true,
          recordKey: urlCapture
        };

        if (
          current?.ready === next.ready &&
          current?.recordKey === next.recordKey
        ) {
          return previous;
        }

        return { ...previous, [tableName]: next };
      });
    }, [
      setDefaultTableSummaryData,
      setdefaultTableSummaryFeild,
      urlCapture
    ]);
    const tablesummaryfields = (e, data) => {
      setTablemaindata(data?.summaryfields?.sSummaryDetails);
      setsummaryfields(e);
    };

    const tablefreeformfield = e => {
      setFreeformfield(e);
    };

    const handledatechange = (e, name) => {
      setTextValue({ ...textValue, [name]: e });
    };

  const autoCompleteOnchange = (
      e,
      name,
      valueObj = {},
      selectedObj = null
    ) => {
      const value =
        e?.target?.value ??
        valueObj?.[name] ??
        e?.value ??
        "";

      setTextValue(prev => ({
        ...prev,
        [name]: value
      }));

      setSelectedComponentData(previous => ({
        ...previous,
        [name]:
          selectedObj &&
          typeof selectedObj === "object" &&
          Object.keys(selectedObj).length > 0
            ? selectedObj
            : null
      }));

      const validationError = validateTextField(
        value,
        validaterules?.[name]
      );

      setError(prev => {
        const next = { ...(prev || {}) };

        if (validationError) {
          next[name] = validationError;
        } else {
          delete next[name];
        }

        return next;
      });
    };

    const handleCheckboxOnchange = (e, name) => {
      setTextValue({ ...textValue, [name]: e });
      setVarValue({ ...varValue, [name]: e});
    };

    // UPDATED - BITS Enterprise.js
    // const handleselectOnchange = (e, name, mainAllData) => {
    //   let value;
    //   if (typeof e === "object") {
    //     value = e.value;
    //   } else {
    //     value = e.toString();
    //   }
    const handleselectOnchange = (
      e,
      name, 
      selectedObject
    ) => {
      const rawValue =
        e?.target?.value ??
        e?.value ??
        e;

      const value =
        rawValue === undefined ||
        rawValue === null
          ? ""
          : String(rawValue);

      setTextValue(previous => ({
        ...(previous || {}),
        [name]: value
      }));

      setSelectedComponentData(previous => ({
        ...previous,
        [name]:
          selectedObject &&
          typeof selectedObject === "object" &&
          Object.keys(selectedObject).length > 0
            ? selectedObject
            : null
      }));

      /*
      * Keep varValue synchronized for components that use it
      * for cascade, visibility, or variable substitution.
      */
      setVarValue(previous => ({
        ...(previous || {}),
        [name]: value
      }));

      const validationError =
        validateTextField(
          value,
          validaterules?.[name]
        );

      setError(previous => {
        const next = {
          ...(previous || {})
        };

        if (validationError) {
          next[name] = validationError;
        } else {
          delete next[name];
        }

        return next;
      });
    };

  const handleradiovalue = (e, name) => {
    const value =
      e?.target?.value ??
      e?.value ??
      e?.sValue ??
      e?.sChoice ??
      e;

    setTextValue(prev => ({ ...prev, [name]: value }));
    setVarValue(prev => ({ ...prev, [name]: value }));
  };

    const getfilename = (files, b, mode, url) => {
      if (
        formData?.form?.sFormAction === "EDIT" &&
        mode === "SINGLE" &&
        typeof files === "string" &&
        files
      ) {
        setTextValue(prevTextValue => ({ ...prevTextValue, [b]: files }));
      } else {
        const fileNames = [];
        setImgUploadURL(url);

        const filesdata = [];
        for (let i = 0; i < files?.length; i++) {
          const fileName = files[i]?.file?.name || files[i]?.src;
          const filedata = files[i]?.file;
          fileNames.push(fileName);
          filesdata.push(filedata);
        }
        if (mode === "SINGLE") {
          setTextValue(prevTextValue => ({ ...prevTextValue, [b]: fileNames[0] }));
          setSingleImg(filesdata[0]);
        } else {
          setTextValue(prevTextValue => ({ ...prevTextValue, [b]: fileNames }));
          setmultiplefileImg(filesdata);
        }
      }
    };

    //List 1
    function useListData(dataDefault) {
      const [listData, setListData] = useState([]);

      useEffect(() => {
        axios
          .get(`${baseURL}${dataDefault}`, {
            headers: {
              Authorization: `Bearer ${token}`
              // Other headers if needed
            }
          })
          .then(result => {
            setListData(result.data);
          })
          .catch(error => {
            // setGlobalError(error);
            console.log(error, "error");
          });
      }, [dataDefault]);

      return listData;
    }

    function DefaultComponent({ dataDefault, data }) {
      const listItems = useListData(dataDefault);
      return ListItemdata(format?.data, data, listItems);
    }

    //
    // List2
    function ListAvatar({ dataDefault, data }) {
      const listAvatarItem = useListData(dataDefault);
      return ListItemdata(format?.data, data, listAvatarItem);
    }

    // List 3
    function ListIcon({ dataDefault, data }) {
      const icon = data?.fieldIcon?.replace("Icon", "");
      const listIconItem = useListData(dataDefault);
      return ListItemdata(format?.data, data, listIconItem, icon);
    }
    //List 4
    function ListAvatarIconItem({ dataDefault, data }) {
      const listAvatarIcon = useListData(dataDefault);
      return ListItemdata(format?.data, data, listAvatarIcon);
    }

    function toggleSwitchState(name, value) {
      setTextValue((prev) => ({ ...prev, [name]: value }));
      if(name in varValue){
        setVarValue((prev) => ({ ...prev, [name]: value }));
      }
    }

    function handleSectionCascade(children) {
      if (!children || !Array.isArray(children)) return;

      const textUpdates = {};
      const varUpdates = {};
      let shouldClearTable = false;

      children.forEach((child) => {
        const sType = child?.component?.sType;
        const sName = child?.component?.sName;
        const sDefaultValue = child?.component?.sDefaultValue;

        if (sType === "INPUTTABLE") {
          shouldClearTable = true;
        } else if (sName !== undefined && sName !== null) {
          textUpdates[sName] = sDefaultValue ?? "";
          varUpdates[sName] = sDefaultValue ?? "";
        }
      });

      if (Object.keys(textUpdates).length > 0) {
        setTextValue((prev) => ({ ...prev, ...textUpdates }));
        setVarValue((prev) => ({ ...prev, ...varUpdates }));
      }

      if (shouldClearTable) {
        setEventSelectTableData({
          data: {
            mainrecord: {},
            tablerecords: [{
              tabledetails: [],
              tablesummary: []
            }]
          }
        });
        setEventSelectTableMapping({});
      }
    }

    const customBoxTextValue = useMemo(() => {
      return {
        ...(varValue || {}),
        ...(initialEditData || {}),
        ...(textValue || {})
      };
    }, [varValue, initialEditData, textValue]);

    const resolveHeaderText = useCallback(
      headerDefinition => {
        const valueSource = {
          ...(varValue || {}),
          ...(initialEditData || {}),
          ...(textValue || {})
        };

        return resolveTitleTemplate(headerDefinition, valueSource);
      },
      [varValue, initialEditData, textValue]
    );

    const renderComponent = (componentData, parentData, ownerFormData = formData) => {
      const renderOwnedComponent = (children, childParentData) =>
        renderComponent(children, childParentData ?? parentData, ownerFormData);

      return (
        <Grid container>
          {componentData?.map((data, ind) => {
            switch (data?.component?.sType) {
              case "TYPOGRAPHY":
                return renderTypography(data, textValue);
              case "TEXTFIELD":
                return renderTextfield(data, ind, index, error, textValue, handleTextValue, varValue);
              case "INPUT": {
                return (
                  <RenderInputComponent 
                    data={data} 
                    setTextValue={setTextValue} 
                    formData={ownerFormData}
                    freeFormTabbleEditMainrecord={freeFormTabbleEditMainrecord} 
                    varValue={varValue}
                    textValue={textValue}
                    setDialogKeyMapping={setDialogKeyMapping}
                  />
                );
              }
              case "COUNTER":
                return (
                  <Counter
                    data={data}
                    ind={ind}
                    index={index}
                    error={error}
                    textValue={textValue}
                    handleTextValue={handleTextValue}
                  />
                );
              case "PASSWORDTEXTFIELD":
                return <RenderPasswordTextfield data={data} ind={ind} textValue={textValue} handleTextValue={handleTextValue} index={index} error={error} />
              case "LINK":
                return renderlinkfield(data, handleLinkOpenModal, openStaticDialog);
              case "AUTOCOMPLETE":
                // alert(JSON.stringify(data))
                return renderAutoComplete(
                  data,
                  error,
                  autoCompleteOnchange,
                  handleclickdata,
                  textValue,
                  formIsSubmited,
                  setSelectAndAutocompleteSname
                );

              case "CHECKBOX":
                return rendercheckbox(data, handleCheckboxOnchange, textValue);

              case "TRANSFERLIST":
                return renderTransferList(data);

              case "RADIOGROUP":
                return renderRadioGroup(data, handleradiovalue, textValue, freeFormTabbleEditArrays, freeFormTabbleEditMainrecord, ownerFormData?.form?.sFormAction);

              case "SELECT":
                return renderSelect(
                  data,
                  error,
                  handleselectOnchange,
                  textValue,
                  handleclickdata,
                  formIsSubmited,
                  setSelectAndAutocompleteSname,
                  setdTermDays,
                  ownerFormData?.form?.sFormAction,
                  isDocumentSelect
                );

              // case "COUNTER":
              //   return renderCounter(data, error, handleselectOnchange, textValue);
              case "CURRENCY":
                return renderCurrency(
                  data,
                  error,
                  company,
                  ind,
                  textValue,
                  handleTextValue,
                  handleTextValue1
                );
              case "FIXVALUE":
                return renderFixedvalue(data, handleselectOnchange);

              case "IMAGE":
                return (
                  <>
                    <ImageComponent
                      value={textValue[data.component.sName]}
                      textValue={textValue}
                      setTextValue={setTextValue}
                      formAction={ownerFormData?.form?.sFormAction}
                      imagesIdsFromMedia={imagesIdsFromMedia}
                      setImagesIdsFromMedia={setImagesIdsFromMedia}
                      openStaticDialog={openStaticDialog}
                      imagesName={imagesName}
                      data={data}
                      bodycontent={bodycontent}
                    />
                  </>
                );
              // case "IMAGE":
              //   return renderImage(
              //     data,
              //     (a, b, mode, url) => getfilename(a, b, mode, url),
              //     bodycontent,
              //     formData?.form?.sFormAction
              //   );

              case "DATETIME":
                return ownerFormData?.form?.id === "dashboard" ? (
                  <DateTimeComponent
                    data={data}
                    textValue={textValue}
                    setTextValue={setTextValue}
                    formaction={ownerFormData?.form?.sFormAction}
                  />
                ) : (
                  <>
                    {/* {JSON.stringify(dTermDays)} */}
                    {renderDatecomponent(
                      data,
                      handledatechange,
                      textValue,
                      ownerFormData,
                      setTextValue,
                      selectedComponentData
                    )}
                  </>
                );
                // Old DATETIME code (before DateTimeComponent):
                // return (
                //   <>
                //     {/* {JSON.stringify(dTermDays)} */}
                //     {renderDatecomponent(data, handledatechange, textValue, formData, setTextValue)}
                //   </>
                // );
              case "DATERANGE":
                return (
                  <DateRangeComponent
                    data={data}
                    textValue={textValue}
                    setTextValue={setTextValue}
                    formaction={ownerFormData?.form?.sFormAction}
                  />
                );
              case "DATETIMERANGE":
                return (
                  <DateTimeRangeComponent
                    data={data}
                    textValue={textValue}
                    setTextValue={setTextValue}
                    formaction={ownerFormData?.form?.sFormAction}
                  />
                );
              case "CUSTOMBOX":
                return (
                  <>
                    <CUSTOMBOX
                      data={data}
                      textValue={customBoxTextValue}
                    />
                  </>
                );
              case "MULTIRECORD":
                return (
                  <Multirecord
                    data={data}
                    format={format}
                    setMultiRecordForBackend={setMultiRecordForBackend}
                    company={company}
                    setmultirecordValidateFunction={setmultirecordValidateFunction}
                    setmultirecordExist={setmultirecordExist}
                    isDisabledTable={isDisabledTable}
                    textValue={textValue}
                    setdifferenceDebitCredit={setdifferenceDebitCredit}
                    isSubmited={isSubmited}
                    tabledata={handletabledata}
                    tablesummaryfields={e => tablesummaryfields(e, data)}
                    tablefreeformfield={tablefreeformfield}
                    freeFormTabbleEditArrays={freeFormTabbleEditArrays}
                    setFreeFormTabbleArrays={setFreeFormTabbleArrays}
                    freeFormTabbleArrays={freeFormTabbleArrays}
                    freeformTableMode={freeformTableMode}
                    freeformTableName={freeformTableName}
                    formAction={ownerFormData?.form?.sFormAction}
                    formdata={ownerFormData}
                    parentData={parentData}
                    uniqueErrors={uniqueErrors}
                    setUniqueErrors={setUniqueErrors}
                  />
                );

              case "INPUTTABLE":
                //  if (data.component.options.mode == "FREEFORM") {
                //   setFreeformTableMode(data?.component?.options.mode);
                //   setFreeformTableName(data?.component.sName);
                // }

                return (
                  <>
                    {/* {JSON.stringify(defaultTableNameAndModel.sName)} */}
                    {/* {JSON.stringify(defaultTableNameAndModel.options.mode)} */}
                    <AllTablesMain
                      data={data}
                      setdefaultTableNameAndModel={setdefaultTableNameAndModel}
                      setSelectAndAutocompleteSname={setSelectAndAutocompleteSname}
                      company={company}
                      setcheckMaxTotalValue={setcheckMaxTotalValue}
                      setallowZeroValue={setallowZeroValue}
                      isDisabledTable={isDisabledTable}
                      textValue={textValue}
                      setdebitCreditTableMode={setdebitCreditTableMode}
                      setdebitCreditTableName={setdebitCreditTableName}
                      handleClickOpen={handleclickdata}
                      setdebitCreditTotal={setdebitCreditTotal}
                      setdebitCreditTotalBalanced={setdebitCreditTotalBalanced}
                      format={format}
                      freeFromTotals={freeFromTotals}
                      setFreeFromTotals={setFreeFromTotals}
                      setdifferenceDebitCredit={setdifferenceDebitCredit}
                      isSubmited={isSubmited}
                      setdebitCreditTableData={setdebitCreditTableData}
                      tabledata={handletabledata}
                      tablesummaryfields={e => tablesummaryfields(e, data)}
                      tablefreeformfield={tablefreeformfield}
                      freeFormTabbleEditArrays={freeFormTabbleEditArrays}
                      freeFormTabbleEditMainrecord={freeFormTabbleEditMainrecord}
                      setFreeFormTabbleEditMainrecord={setFreeFormTabbleEditMainrecord}
                      setFreeFormTabbleArrays={setFreeFormTabbleArrays}
                      freeFormTabbleArrays={freeFormTabbleArrays}
                      freeformTableMode={freeformTableMode}
                      freeformTableName={freeformTableName}
                      formAction={ownerFormData?.form?.sFormAction}
                      formdata={ownerFormData}
                      documentSelectTableData={documentSelectTableData}
                      documentSelectmappingData={documentSelectmappingData}
                      eventSelectTableData={eventSelectTableData}
                      eventSelectTableMapping={eventSelectTableMapping}
                      setfreeFormValidateFunction={setfreeFormValidateFunction}
                      setmultirecordValidateFunction={setmultirecordValidateFunction}
                      setmultirecordExist={setmultirecordExist}
                      setdefaultTableValidateFunction={setdefaultTableValidateFunction}
                      setdebitCreditValidateFunction={setdebitCreditValidateFunction}
                      documentSelectKey={documentSelectKey}
                      uniqueErrors={uniqueErrors}
                      setUniqueErrors={setUniqueErrors}
                      isResponseArrived={isResponseArrived}
                      isEditRecordHydrated={isEditRecordHydrated}
                      onDefaultTableHydrationChange={handleDefaultTableHydration}
                      documentSelectMainRecordData={documentSelectMainRecordData}
                      documentSelectMainRecordObject={documentSelectMainRecordObject}
                      currencyOptions={currencyOptions}
                      setCurrencyOptions={setCurrencyOptions} 
                      selectedCurrency={selectedCurrency}
                      setSelectedCurrecy={setSelectedCurrecy}
                    />
                  </>
                );
                
                case "BUTTON":
                // alert(JSON.stringify(data))
                return renderButtonComponent(
                  data,
                  handleclickdata,
                  openModalDataActive.sFormName || mainFormData?.form?.sFormName,
                  ownerFormData,
                  isResponseArrived &&
                    (data?.component?.options?.handler !== "handleSubmit" || defaultTablesReady),
                  textValue,
                  dialogKeyMapping,
                  bulkData,
                  handleButtonTerminateSignal
                );

              case "BUTTONDROPDOWN":
                return (
                  <ButtonDropdown
                    data={data}
                    handleclickdata={handleclickdata}
                    formName={openModalDataActive.sFormName || ownerFormData?.form?.sFormName}
                    formData={ownerFormData}
                    formValues={textValue}
                    isResponseArrived={
                      isResponseArrived &&
                      (data?.component?.options?.handler !== "handleSubmit" || defaultTablesReady)
                    }
                  />
                );

              case "FILE":
                return (
                  <FileUpload
                    editFiledata={editFiledata}
                    type={ownerFormData?.form?.sFormAction}
                    data={data}
                    setFilesForBackend={setFilesForBackend}
                    handleclickdata={handleclickdata}
                  />
                );

              case "VARSELECT":
                return (
                  <Varselect error={error} ind={ind} data={data} handleclickdata={handleTextValue} />
                );
              case "NUMBER":
                return (
                  <NUMBER
                    ind={ind}
                    index={index}
                    error={error}
                    textValue={textValue}
                    data={data}
                    handleTextValue={handleTextValue1}
                  />
                );
              case "DOCUMENTSELECT":
                return (
                  // documentSelectTableData,
                  // documentSelectmappingData
                  <DocumentSelect
                    setdocumentSelectmappingData={setdocumentSelectmappingData}
                    setdocumentSelectTableData={setdocumentSelectTableData}
                    setselectedRowsDataGrid={setselectedRowsDataGrid}
                    selectedRowsDataGrid={selectedRowsDataGrid}
                    renderComponent={renderOwnedComponent}
                    data={data}
                    setDocumentSelectKey={setDocumentSelectKey}
                    setDocumentSelectMainRecordData={setDocumentSelectMainRecordData}
                    setDocumentSelectMainRecordObject={setDocumentSelectMainRecordObject}
                    setIsDocumentSelect={setIsDocumentSelect}
                  />
                );

              case "DATAGRID":
                return (
                  <Grid item {...data?.grid_props}>
                    <DataGridComponent
                      key={`${route}|${data?.component?.sName || "DATAGRID"}|${data?.data?.sDataSource || ""}`}
                      data={ownerFormData}
                      setselectedRowsDataGrid={setselectedRowsDataGrid}
                      formdata={data}
                      format={format}
                      formDetails={ownerFormData?.form}
                      {...data?.component?.sProps}
                      setFreeFormTabbleEditMainrecord={setFreeFormTabbleEditMainrecord }
                      dataGridModalOpen={dataGridModalOpen} 
                      setDataGridModalOpen={setDataGridModalOpen}
                      refreshData={refreshData}
                      setRefreshData={setRefreshData}
                      dataGridRetention={dataGridRetention}
                      setDataGridRetention={setDataGridRetention}
                      bulkActionLoader={bulkActionLoader}
                      setBulkActionLoader={setBulkActionLoader}
                    />
                  </Grid>
                );
              case "DATATABLE":
                {
                  /* rfg 8 May 23 */
                }
                return (
                  <Grid item {...data?.grid_props}>
                    {/* {JSON.stringify(varValue)} */}
                    <DataTableComponent
                      renderComponent={renderOwnedComponent}
                      formdata={data}
                      setVarValue={setVarValue}
                      varValue={varValue}
                      format={format}
                      formDetails={ownerFormData?.form}
                      recordData={recordData}
                      {...data?.component?.sProps}
                    />
                  </Grid>
                );
              case "BOX": {
                return (
                  <Grid item {...data?.grid_props}>
                    <Box {...data?.component?.sProps} id={data?.component?.sName}>
                      {renderOwnedComponent(data?.child)}
                    </Box>
                  </Grid>
                );
              }
              case "REPORTSDESIGNER": {
                return (
                  <ReportsDesigner
                    data={data}
                    formData={ownerFormData}
                    reportData={reportData}
                    setReportData={setReportData}
                  />
                );
              }
              case "REPORTBROWSER": {
                return (
                  <ReportBrowser 
                    data={data} 
                    formData={ownerFormData}
                    sethandleModalclick={sethandleModalclick} 
                    reportData={reportData}
                  />
                )
              }
              case "SECTION": {
                // return (
                //   /true/.test(data?.component?.options?.visible) && (
                //     <Grid item {...data?.grid_props}>
                //       <Box {...data?.component?.sProps} id={data?.component?.sName}>
                //         <Grid container>
                //           {/* {JSON.stringify(data?.child)} */}
                //           {renderComponent(data?.child)}
                //         </Grid>
                //       </Box>
                //     </Grid>
                //   )
                // );
                return (
                  <SECTION data={data} textValue={textValue} renderComponent={renderOwnedComponent} varValue={varValue} handleSectionCascade={handleSectionCascade} />
                );
              }
              case "PAPER": {
                return (
                  <Grid item {...data.grid_props}>
                    {/* {JSON.stringify(data)} */}
                    {/* {JSON.stringify(data?.component?.sProps)} */}
                    <Paper
                      id={data.component.sName}
                      sx={data?.component?.sProps}
                      {...data?.component?.sProps}
                    >
                      <Grid container {...data?.component?.options?.others1}>
                        {renderOwnedComponent(data?.child)}
                      </Grid>
                    </Paper>
                  </Grid>
                );
              }

              case "CARD": {
                return renderCardComponent(data, handleclickdata);
              }

              case "GLOBALTEXT": {
                return renderglobaltextcomponent(data, globalvariables, format);
              }
              case "DIVIDER": {
                return (
                  <Grid item {...data.grid_props}>
                    <Divider {...data?.component?.sProps}>{renderOwnedComponent(data?.child)}</Divider>
                  </Grid>
                );
              }
              case "STACK":
                return (
                  <Grid item {...data?.grid_props}>
                    <Stack {...data?.component?.sProps}>
                      <Grid container {...data?.component?.options?.others1}>
                        {data?.child?.map(item1 => {
                          switch (item1?.component?.sType) {
                            case "TYPOGRAPHY":
                              return renderTypography(item1, textValue);
                            default:
                              return null;
                          }
                        })}
                      </Grid>
                    </Stack>
                  </Grid>
                );
              case "ICON": {
                const icon = data?.component?.sIcon?.replace("Icon", "");
                return (
                  <Grid item {...data?.grid_props}>
                    <Icon id={data?.component?.sName} {...data?.component?.sProps} iconName={icon} />
                  </Grid>
                );
              }
              case "VARDATETIME": {
                return (
                  <>
                    <VarDateTime data={data} value={textValue[data.component.sName] ? textValue[data.component.sName] : varValue[data.component.sName]} />
                  </>
                );
              }
              case "AVATAR": {
                return avatarcomponent(data);
              }
              case "VARTEXT": {
                // return rendervartextcomponent(data, varValue, format,setVarValue);
                return <Vartext data={data} varValue={varValue} format={format} />;
              }
              case "VARNUMBER": {
                // return rendervartextcomponent(data, varValue, format,setVarValue);
                return <VARNUMBER data={data} varValue={varValue} format={format} />;
              }
              case "VARGROUP": {
                return <VARGROUP data={data} varValue={varValue} format={format} renderComponent={renderComponent} />;
              }
              case "LISTENER-SECTION": {
                return <ListenerSection data={data} varValue={varValue} renderComponent={renderComponent} />;
              }
              case "VARCONCAT": {
                // return rendervartextcomponent(data, varValue, format,setVarValue);
                return <VarConcat data={data} varValue={varValue} format={format} />;
              }
              case "VARCUSTOMHTML": {
                // return rendervartextcomponent(data, varValue, format,setVarValue);
                return <VARCUSTOMHTML data={data} varValue={varValue} format={format} />;
              }
              case "VARIMAGE": {
                return <VarImage data={data} varValue={varValue} />;
              }
              case "EVENT": {
                return (
                  <EVENT
                    data={data}
                    setTextValue={setTextValue}
                    setVarValue={setVarValue}

                    setdocumentSelectTableData={
                      setdocumentSelectTableData
                    }
                    setdocumentSelectmappingData={
                      setdocumentSelectmappingData
                    }
                    setDocumentSelectKey={
                      setDocumentSelectKey
                    }

                    setDocumentSelectMainRecordData={
                      setDocumentSelectMainRecordData
                    }
                    setDocumentSelectMainRecordObject={
                      setDocumentSelectMainRecordObject
                    }
                    setIsDocumentSelect={
                      setIsDocumentSelect
                    }

                    setEventSelectTableData={
                      setEventSelectTableData
                    }
                    setEventSelectTableMapping={
                      setEventSelectTableMapping
                    }
                  />
                );
              }
              case "IMG": {
                let srcImg = `${baseURL}${data?.data?.sDataSource}`;
                const sProps = {
                  ...data?.component?.sProps
                };
                const { sx } = sProps;
                const mappedSx = {
                  width: parseInt(sx?.width),
                  height: parseInt(sx?.height)
                };
                return (
                  <>
                    {/* kk
                  {JSON.stringify(data)} */}
                    <ImgComponent
                      data={data}
                      imagesIdsFromMedia={imagesIdsFromMedia}
                      setImagesIdsFromMedia={setImagesIdsFromMedia}
                      value={textValue[data.component.sName]}
                      textValue={textValue}
                      setTextValue={setTextValue}
                      formAction={ownerFormData?.form?.sFormAction}
                      openStaticDialog={openStaticDialog}
                      imagesName={imagesName}
                      bodycontent={bodycontent}
                    />
                  </>
                );
              }
              case "AVATARGROUP": {
                return (
                  <Grid item {...data.grid_props}>
                    <AvatarGroup {...data?.component?.sProps}>
                      {data?.child?.map(item1 => {
                        if (item1?.component?.sType === "AVATAR") {
                          return avatarcomponent(item1);
                        }
                      })}
                    </AvatarGroup>
                  </Grid>
                );
              }
              case "TAB":
                return <BasicTabs data={data} renderComponent={renderComponent} />;
              case "BUTTONGROUP": {
                return (
                  <Grid item {...data.grid_props}>
                    <ButtonGroup id={data?.component?.sName} {...data?.component?.sProps}>
                      {data?.child?.map(item1 => {
                        switch (item1?.component?.sType) {
                          case "BUTTON":
                            return renderButtonComponent(item1, handleclickdata);
                          default:
                            return null;
                        }
                      })}
                    </ButtonGroup>
                  </Grid>
                );
              }
              case "BADGE": {
                const icon = data?.component?.sIcon?.replace("Icon", "");
                return data?.component?.sType === "BADGE" ? (
                  <Grid item {...data?.grid_props}>
                    <Badge {...data?.component?.sProps}>
                      <Icon {...data?.component?.options?.others1} iconName={icon} />
                    </Badge>
                  </Grid>
                ) : null;
              }

              case "VARVALUE": {
                return (
                  <Grid item {...data?.grid_props}>
                    <VarValue data={data} textValue={{...textValue, "sShippingID": shippingId}} />
                  </Grid>
                );
              }

              case "ACCORDION": {
                return (
                  <>
                    <AccordianComponent
                      textValue={textValue}
                      data={data}
                      renderComponent={renderComponent}
                    />
                    {/* <Grid item {...data?.grid_props}>
                    <Accordion {...data?.component?.sProps}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>{data?.component?.sTitle}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>{renderOwnedComponent(data.child)}</AccordionDetails>
                    </Accordion>
                  </Grid> */}
                  </>
                );
              }
              // case "ACCORDION2": {
              //   return (
              //     <Grid item xs={8}>
              //       <Accordion>
              //         <AccordionSummary
              //           expandIcon={<ExpandMoreIcon />}
              //           aria-controls="panel1a-content"
              //           id="panel1a-header"
              //         >
              //           <Typography>Purchase Orders</Typography>
              //         </AccordionSummary>
              //         <AccordionDetails></AccordionDetails>
              //       </Accordion>
              //       <Accordion>
              //         <AccordionSummary
              //           expandIcon={<ExpandMoreIcon />}
              //           aria-controls="panel2a-content"
              //           id="panel2a-header"
              //         >
              //           <Typography>Bills</Typography>
              //         </AccordionSummary>
              //         <AccordionDetails></AccordionDetails>
              //       </Accordion>
              //       <Accordion>
              //         <AccordionSummary
              //           expandIcon={<ExpandMoreIcon />}
              //           aria-controls="panel2a-content"
              //           id="panel2a-header"
              //         >
              //           <Typography>Payment Made</Typography>
              //         </AccordionSummary>
              //         <AccordionDetails></AccordionDetails>
              //       </Accordion>
              //       <Accordion>
              //         <AccordionSummary
              //           expandIcon={<ExpandMoreIcon />}
              //           aria-controls="panel2a-content"
              //           id="panel2a-header"
              //         >
              //           <Typography>Debit Notes</Typography>
              //         </AccordionSummary>
              //         <AccordionDetails></AccordionDetails>
              //       </Accordion>
              //       <Accordion>
              //         <AccordionSummary
              //           expandIcon={<ExpandMoreIcon />}
              //           aria-controls="panel2a-content"
              //           id="panel2a-header"
              //         >
              //           <Typography>Payments Received</Typography>
              //         </AccordionSummary>
              //         <AccordionDetails></AccordionDetails>
              //       </Accordion>
              //       <Accordion>
              //         <AccordionSummary
              //           expandIcon={<ExpandMoreIcon />}
              //           aria-controls="panel2a-content"
              //           id="panel2a-header"
              //         >
              //           <Typography>Expenses</Typography>
              //         </AccordionSummary>
              //         <AccordionDetails></AccordionDetails>
              //       </Accordion>
              //     </Grid>
              //   );
              // }
              case "CHIP":
                // return renderchipcomponent(data)
                return (
                  <Grid item {...data.grid_props}>
                    {(() => {
                      switch (data?.component?.sAdornType) {
                        case "NONE":
                          if (data?.component.sName === "sStatus") {
                            const foundItem = format.data?.find(item => item?.sFieldFormat);
                            const fieldFormat = foundItem ? JSON.parse(foundItem.sFieldFormat) : {};

                            return (
                              <Grid item {...data?.component?.grid_props}>
                                <Chip label={textValue[data?.component.sName]} {...fieldFormat} />
                              </Grid>
                            );
                          }
                          break;

                        case "IMG":
                          return (
                            <Grid item {...data?.component?.grid_props}>
                              <Chip
                                avatar={
                                  <Avatar
                                    alt={data?.data?.sAction}
                                    src={`${serverAddress}${data?.data?.sDataSource}`}
                                    {...data?.component?.sProps}
                                  />
                                }
                                label={textValue[data?.component.sName]}
                              />
                            </Grid>
                          );
                        case "ICON":
                          return (
                            <Grid item {...data?.component?.grid_props}>
                              <Chip
                                icon={<Icon iconName={data?.component?.sIcon?.replace("Icon", "")} />}
                                label={textValue[data?.component.sName]}
                                {...data?.component?.sProps}
                              />
                            </Grid>
                          );
                        case "LINK":
                          return (
                            <Grid item {...data?.component?.grid_props}>
                              <Chip
                                label={textValue[data?.component.sName]}
                                onClick={() => navigate(data?.component?.options?.others2)}
                              />
                            </Grid>
                          );
                        default:
                          return null;
                      }
                    })()}
                  </Grid>
                );

              case "LISTITEMS": {
                return (
                  <Grid item {...data.grid_props}>
                    {(() => {
                      switch (data?.component?.options?.mode) {
                        case "DEFAULT":
                          return (
                            <DefaultComponent
                              dataDefault={data?.data?.sDataSource}
                              data={data}
                              format={format}
                            />
                          );
                        case "AVATAR":
                          return (
                            <ListAvatar
                              dataDefault={data?.data?.sDataSource}
                              data={data}
                              format={format}
                            />
                          );
                        case "ICON":
                          return (
                            <ListIcon
                              dataDefault={data?.data?.sDataSource}
                              data={data}
                              format={format}
                            />
                          );
                        case "LISTAVATARICON":
                          return (
                            <ListAvatarIconItem
                              dataDefault={data?.data?.sDataSource}
                              data={data}
                              format={format}
                            />
                          );
                        default:
                          return null;
                      }
                    })()}
                  </Grid>
                );
              }
              case "LOADFROM":
                return <Loadfrom data={data} />;
              case "DIALOG":
                // alert(JSON.stringify(open))
                // if (dialogMode?.options?.nested) {
                //   return renderNestedDialog(data,nestedDialog,dialogMode,handleClose,renderComponent)
                // } else {
                return renderdialogboxcomponent(
                  data,
                  open,
                  handleClose,
                  dialogMode,
                  renderComponent,
                  nestedDialog,
                  nestedDialogMode,
                  textValue,
                  showBulkActionLoading
                );
              case "VARSTORE":
                return (
                  <RenderVarstore freeFormTabbleEditMainrecord={freeFormTabbleEditMainrecord} data={data} />
                );
              case "BARCHART":
                return (
                  <Grid item {...data?.grid_props}>
                    <RenderBarchart data={data} />
                  </Grid>
                )
              case "LINECHART":
                return (
                  <Grid item {...data?.grid_props}>
                    <RenderLineChart data={data} />
                  </Grid>
                )
              case "PIECHART":
                return (
                  <Grid item {...data?.grid_props}>
                    <RenderPieChart data={data} />
                  </Grid>
                )
              case "SWITCH":
                return (
                  <Grid item {...data?.grid_props}>
                    <RenderSwitchComponent 
                      data={data} 
                      freeFormTabbleEditMainrecord={freeFormTabbleEditMainrecord}
                      toggleSwitchState={toggleSwitchState}
                      formData={ownerFormData}
                    />
                  </Grid>
                )
              case "TREE":
                return (
                  <Grid item {...data?.grid_props}>
                    <RenderTreeComponent 
                      data={data} 
                      setTextValue={setTextValue}
                      freeFormTabbleEditMainrecord={freeFormTabbleEditMainrecord}
                    />
                  </Grid>
                )
              default:
                return null;
            }
          })}
        </Grid>
      );
    };

    // find all initial data
    const handleTime = event => {
      const item_date = `${event.$D}-${event.$M + 1}-${event.$y}`;
      return item_date;
    };

    function removeCommas(inputString) {
      let result = "";
      for (let i = 0; i < inputString.length; i++) {
        if (inputString[i] !== ",") {
          result += inputString[i];
        }
      }
      return result;
    }

    const handlePointChangeTable = (num1, decimalPlaces = 0, sThousandSeparator) => {
      const num = removeCommas(num1.replace(/\s/g, ","));

      // let val = inputValue.includes(".") ? parseFloat(formattedValue).toFixed(decimalPlaces) : formattedValue;
      let val;
      const inputValue = num.toString();

      if (inputValue.includes(".")) {
        const arr = inputValue.split(".");
        const lastValue = arr[1];
        const newInputValue = inputValue.toString().replace(".", "");
        const lastValueueLenght = lastValue.toString().length;
        const STRVAL = newInputValue.toString();
        const arrval = STRVAL.split("");
        const newArr = lastValue.split("");

        if (decimalPlaces == 0) {
          val = num * 1000;
        }

        if (decimalPlaces == 1) {
          val = lastValue / 10;
          if (arr[0] !== "0") {
            val = `${arr[0]}${lastValue / 10}`;
          }
        }
        if (decimalPlaces == 2) {
          if (lastValueueLenght === 2) {
            val = `${arr[0]}.${lastValue}`;
          } else {
            const joinVal = arrval.slice(0, -2).join("");
            val = `${parseFloat(joinVal)}.${arrval[arrval.length - 2]}${arrval[arrval.length - 1]}`;
          }
        }
        if (decimalPlaces == 3) {
          const joinVal = arrval.slice(0, -3).join("");

          if (newArr.length == 3) {
            val = `${parseFloat(joinVal)}.${newArr[0]}${newArr[1]}${newArr[2]}`;
          } else {
            val = `${parseFloat(joinVal)}.${newArr[1]}${newArr[2]}${newArr[3]}`;
          }
        }
        if (decimalPlaces == 4) {
          const joinVal = arrval.slice(0, -4).join("");
          if (newArr.length == 3) {
            val = `${0}.0${newArr[0]}${newArr[1]}${newArr[2]}`;
          } else {
            val = `${parseFloat(joinVal)}.${newArr[1]}${newArr[2]}${newArr[3]}${newArr[4]}`;
          }
        }

        if (decimalPlaces == 5) {
          const joinVal = arrval.slice(0, -5).join("");
          if (newArr.length == 3) {
            val = `${0}.00${newArr[0]}${newArr[1]}${newArr[2]}`;
          } else {
            val = `${parseFloat(joinVal)}.${newArr[1]}${newArr[2]}${newArr[3]}${newArr[4]}${
              newArr[5]
            }`;
          }
        }
      } else {
        if (decimalPlaces == 0) {
          val = inputValue;
          parseFloat(val).toFixed(decimalPlaces);
        }
        if (decimalPlaces == 1) {
          val = `0.${inputValue}`;
        }
        if (decimalPlaces == 2) {
          val = `0.0${inputValue}`;
        }
        if (decimalPlaces == 3) {
          val = `0.00${inputValue}`;
        }
        if (decimalPlaces == 4) {
          val = `0.000${inputValue}`;
        }
        if (decimalPlaces == 5) {
          val = `0.0000${inputValue}`;
        }
      }

      const newVal = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
        // useGrouping:true
      }).format(
        isNaN(val) ? (decimalPlaces == "0" ? "0" : `${"0"}${"0".repeat(decimalPlaces)}`) : val
      );

      if (sThousandSeparator == ",") {
        return newVal;
      } else {
        return newVal.replace(/,/g, " ");
      }
      // return isNaN(val) ? decimalPlaces : val;
    };
    function filterComponentsRecursive(config) {
      const result = {};

      function processField(field) {
        const component = field.component || {};
        const {
          sType,
          sName,
          sDefaultValue,
          sSendFormat,
          sUncheckedValue,
          iDecimalPlaces,
          sThousandSeparator
        } = component;

        if (
          [
            "TEXTFIELD",
            "COUNTER",
            "AUTOCOMPLETE",
            "CHECKBOX",
            "TRANSFERLIST",
            "RADIOGROUP",
            "PASSWORDTEXTFIELD",
            "FIXVALUE",
            "SELECT",
            "VARTEXT",
            "VARNUMBER",
            "IMG",
            "VARCONCAT",
            "RADIOGROUP",
            "NUMBER",
            "VARSELECT",
            "IMAGE",
            "DATETIME",
            "INPUT"
          ].includes(sType)
        ) {
          // Check if sType is CHECKBOX and default value is an empty string
          if (sType === "CHECKBOX") {
            result[sName] = sDefaultValue !== "" ? sDefaultValue || sUncheckedValue : sUncheckedValue;
          } else if (sType === "RADIOGROUP") {
            //data?.component?.sProps?.defaultValue
            result[sName] = component.sProps.defaultValue;
          } else if (sType === "DATETIME") {
            const date = handleTime(dayjs(sDefaultValue));
            result[sName] = dateformat(date, sSendFormat);
          } else if (sType === "COUNTER") {
            result[sName] =
              component?.options?.sDefaultValue === "Yes"
                ? component.options.enabledValue
                : component.options.mode === "DEFAULT"
                ? sDefaultValue
                : "";
          } else if (sType === "NUMBER") {
            const val = handlePointChangeTable(sDefaultValue, iDecimalPlaces, sThousandSeparator);

            result[sName] = sDefaultValue == "" ? "" : val || "";
          } else {
            result[sName] = sDefaultValue || "";
          }
        }

        // Check if the field has a child array
        if (sType !== "DIALOG") {
          if (field.child && Array.isArray(field.child)) {
            // Nest child array data under the corresponding sName
            result[sName] = result[sName] || {};
            result[sName].child = {
              sType: sType,
              sInputTableName: sName,
              tabledetails: [filterComponentsRecursive(field.child)]
            };
            // Check if component.options.mode is present
            if (component.options) {
              result[sName].child.sInputTableMode = component.options.mode;
            }
          }
        }
      }
      config.forEach(processField);
      return result;
    }

    function getDataByType(sType, dataObject) {
      const result = [];

      function traverse(obj) {
        if (obj && obj.sType === sType) {
          result.push(obj);
        }

        for (const key in obj) {
          if (obj.hasOwnProperty(key) && typeof obj[key] === "object") {
            traverse(obj[key]);
          }
        }
      }

      traverse(dataObject);

      return result;
    }
    //  getting data by sname
    function getDataByName(obj, targetName) {
      if (obj && typeof obj === "object") {
        if (targetName in obj) {
          return obj[targetName];
        } else {
          for (const key in obj) {
            const result = getDataByName(obj[key], targetName);
            if (result !== null) {
              return result;
            }
          }
        }
      }
      return null;
    }

    function getDataByMode(obj, modeToFind) {
      const resultArray = [];
      function search(obj) {
        if (obj && typeof obj === "object") {
          if ("mode" in obj && obj.mode === modeToFind) {
            resultArray.push(obj);
          }

          for (const key in obj) {
            search(obj[key]);
          }
        }
      }

      search(obj);
      return resultArray;
    }

    const [intdata, setinitdata] = useState([]);
    function extractDynamicData(jsonData, result = {}, excludedKeys = []) {
      if (jsonData.sType != "DOCUMENTSELECT") {
        if (jsonData.sType != "MULTIRECORD") {
          if (jsonData.sType !== "INPUTTABLE") {
            for (const key in jsonData) {
              if (!excludedKeys.includes(key)) {
                if (typeof jsonData[key] === "object" && jsonData[key] !== null) {
                  extractDynamicData(jsonData[key], result, excludedKeys);
                } else {
                  result[key] = jsonData[key] || "";
                }
              }
            }
          }
        }
      }

      return result;
    }

    const yourConfig = formData?.details; // Replace this with your actual configuration
    function SettingInitialValues({ preserveExisting = false } = {}) {
      if (yourConfig) {
        const filteredComponents = filterComponentsRecursive(yourConfig);
        const tableData = getDataByType("INPUTTABLE", filteredComponents);
        const tab = getDataByType("TAB", filteredComponents);
        const excludedKeys = [
          // "sMode",
          "mode",
          "DIALOG",
          "DOCUMENTSELECT",
          "sType",
          "inventory_image",
          "sInputTableMode",
          "sInputTableName"
        ];

        const extractedData = extractDynamicData(filteredComponents, {}, excludedKeys);
        // alert(JSON.stringify(extractedData))

        let rtnData = {};
        // if (Object.keys(varValue).length > 0 ) {
        // alert(JSON.stringify(extractedData))
        rtnData = copyMatchingValues(varValue, extractedData);
        // alert(JSON.stringify(varValue))
        setTextValue(prev => {
          const nextValues = preserveExisting
            ? { ...(rtnData || {}), ...(prev || {}) }
            : rtnData;

          return JSON.stringify(prev || {}) === JSON.stringify(nextValues || {})
            ? prev
            : nextValues;
        });

        setinitdata(prev =>
          JSON.stringify(prev || []) === JSON.stringify(tableData || [])
            ? prev
            : tableData
        );

        setFreeFormInitState(prev =>
          JSON.stringify(prev || []) === JSON.stringify(tableData || [])
            ? prev
            : tableData
        );

        setFreeFormTabbleArrays(prev =>
          JSON.stringify(prev || []) === JSON.stringify(tableData || [])
            ? prev
            : tableData
        );

        setfilterfreeForm(prev =>
          JSON.stringify(prev || []) === JSON.stringify(tableData || [])
            ? prev
            : tableData
        );
        try {
          /* eslint-disable no-fallthrough */
          /*global copyTableInormation, a*/
          /*eslint no-undef: "error"*/
          // copyTableInormation(formData?.form?.sFormName, tableData, textValue);
          /*eslint no-undef: "error"*/
          /* eslint-disable no-fallthrough */
        } catch (error) {
          console.log(error);
        }
      }
    }

    function hasFile(object) {
      if (object?.component?.sType === "FILE") {
        return true;
      }
      if (object.child && hasFile(object.child)) {
        return true;
      }
      return false;
    }
    /* eslint-disable no-fallthrough */
    useEffect(() => {
      if (formData) {
        const fileExists = formData?.details?.some(obj => hasFile(obj));
        setIsFileUpload(fileExists);
      }
    }, [formData]);
      
      useEffect(() => {
        SettingInitialValues({ preserveExisting: true });
      }, [formData])


    //----------------------------------------------------------------
    const [typingTimer, setTypingTimer] = useState(null);

    // const textValueDependencyKey = useMemo(() => {
    //   return JSON.stringify(textValue || {});
    // }, [textValue]);

    useEffect(() => {
      if (yourConfig) {
        const filteredComponents = filterComponentsRecursive(yourConfig);
        const tableData = getDataByType("INPUTTABLE", filteredComponents);

        try {
          if (tableData.length > 0) {
            const mostdata = tableData.map((item) => {
              const tableRow = item.tabledetails?.[0] || {};

              return {
                sInputTableMode: item.sInputTableMode,
                sInputTableName: item.sInputTableName,
                sType: item.sType,
                tabledetails: [{ ...tableRow }]
              };
            });

            setFreeFormTabbleArrays(prev => {
              const isSame =
                JSON.stringify(prev || []) === JSON.stringify(mostdata || []);

              return isSame ? prev : mostdata;
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }, [formData]);

    const [staticDialog, setStaticDialog] = useState(false);
    const [imagesName, setImageName] = useState("");

    function openStaticDialog(data, sName) {
      setStaticDialog(data);
      setImageName(sName);
    }

    const [cloneFormData, setCloneFormData] = useState([]);
    const [cloneRecordData, setCloneRecordData] = useState({});
    const overlayWasOpenRef = React.useRef(false);

    // const []
    useEffect(() => {
      if (overlaySplit) {
        overlayWasOpenRef.current = true;
        return;
      }

      setCloneFormData(formData);

      if (overlayWasOpenRef.current) {
        overlayWasOpenRef.current = false;
        return;
      }

      setCloneRecordData(recordData);
      // setmainFormData({});
    }, [formData, recordData, overlaySplit]);

    const backgroundFormData = cloneFormData?.form ? cloneFormData : formData;

    function closeAlertPopup() {
      setIsAlertPopup(false);
      navigate(-1);
    }

    if(isAlertPopup?.open){
      return (<AlertPopup open={isAlertPopup} setClose={closeAlertPopup} />)
    }

    return (
      <>
        <Grid
          id={backgroundFormData?.form?.sFormName}
          container
          {...backgroundFormData?.form?.sGridProps}
          key={backgroundFormData?.form?.id}
        >
          <Grid item xs={12}>
            {!isPageLoading && (!isViewDataLoading || overlaySplit) ? (
              [cloneFormData]?.map(item => {
                return (
                  <>
                    <Grid
                      id="mainform-grid"
                      container
                      {...item?.form?.sGridProps}
                      key={item?.form?.id}
                    >
                      {/* {globalError && <MessageError message={globalError} />} */}
                      {/* <Grid item md={12} py={1}> */}

                      <TitleHeader
                        item={item}
                        style={{ ...item?.form?.sProps }}
                        formData={item}
                        title={item?.form?.sTitle}
                        titleText={resolveHeaderText(item?.form?.sTitle)}
                        subTitle={item?.form?.sSubTitle}
                        subTitleText={resolveHeaderText(item?.form?.sSubTitle)}
                      />

                      <SSEInfoAlert enabled={!overlaySplit && !isDialogDrawerOpen} />

                      {/* <Typography {...item?.form?.sProps}>{item?.form?.sTitle}</Typography> */}
                      {/* </Grid> */}
                      {/* <Grid item md={12}>
                        <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" href="/">
                        {item?.form?.sBreadCrumbs}
                        </Link>
                        </Breadcrumbs>
                        </Grid> */}
                      <Grid container id={item?.form?.sFormName + "-menu"}>
                        {" "}
                        {/* Form Menu */}
                        <FormBar toggle={0} item={item} menu={item?.form?.sMenu} recordData={cloneRecordData} />
                      </Grid>

                      {location?.state?.dialog ? (
                        <Dialog fullWidth={true} open={true}>
                          <Box style={{ margin: "10px" }}> {renderComponent(item?.details, undefined, item)}</Box>
                        </Dialog>
                      ) : (
                        <Box style={{ marginTop: item?.form?.sMenu === "" ? "50px" : 0 }}> </Box>
                      )}
                      {isAlertPopup.open && (
                        <AlertPopup open={isAlertPopup} setClose={setIsAlertPopup} />
                      )}

                      {/* {JSON.stringify(bPayloads)} */}
                      {/* {JSON.stringify(freeFormTabbleArrays)}  */}

                      {renderComponent(item?.details, undefined, item)}

                      {staticDialog && <MediaDialog
                        setImageName={setImageName}
                        imagesName={imagesName}
                        setImagesIdsFromMedia={setImagesIdsFromMedia}
                        open={staticDialog}
                        setOpen={setStaticDialog}
                      />}
                      <FormFooter formData={item?.footer} renderComponent={children => renderComponent(children, undefined, item)} />
                    </Grid>
                  </>
                );
              })
            ) : (
              <div
                style={{
                  height: "75vh",
                  width: "80vw",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div>
                  <Spinner />
                </div>
              </div>
            )}
          </Grid>

          {overlaySplit && (
            <Grid item xs={6}>
              <OverLayDrawer
                cloneFormData={cloneFormData}
                formData={formData}
                setFormData={setFormData}
                isOpen={overlaySplit}
                setIsOpen={setOverLaySplit}
              >
                {!isoverLayDataLoading ? (
                  [formData]?.map(item => {
                    return (
                      <>
                        <Grid
                          id="mainform-grid"
                          container
                          {...item?.form?.sGridProps}
                          key={item?.form?.id}
                        >
                          {/* {globalError && <MessageError message={globalError} />} */}
                          {/* <Grid item md={12} py={1}> */}

                          <TitleHeader
                            item={item}
                            style={{ ...item?.form?.sProps }}
                            formData={item}
                            title={item?.form?.sTitle}
                            titleText={resolveHeaderText(item?.form?.sTitle)}
                            subTitle={item?.form?.sSubTitle}
                            subTitleText={resolveHeaderText(item?.form?.sSubTitle)}
                          />

                          <SSEInfoAlert enabled={overlaySplit && !isDialogDrawerOpen} />

                          <Grid container id={item?.form?.sFormName + "-menu"}>
                            {" "}
                            {/* Form Menu */}
                            <FormBar toggle={0} item={item} menu={item?.form?.sMenu} recordData={recordData} />
                          </Grid>

                          {location?.state?.dialog ? (
                            <Dialog fullWidth={true} open={true}>
                              <Box style={{ margin: "10px" }}> {renderComponent(item?.details, undefined, item)}</Box>
                            </Dialog>
                          ) : (
                            <Box style={{ marginTop: item?.form?.sMenu === "" ? "50px" : 0 }}> </Box>
                          )}
                          {isAlertPopup.open && (
                            <AlertPopup open={isAlertPopup} setClose={setIsAlertPopup} />
                          )}

                          {renderComponent(item?.details, undefined, item)}

                          <MediaDialog
                            setImageName={setImageName}
                            imagesName={imagesName}
                            setImagesIdsFromMedia={setImagesIdsFromMedia}
                            open={staticDialog}
                            setOpen={setStaticDialog}
                          />
                          {/* {JSON.stringify(lund())}dd */}
                          <FormFooter formData={item?.footer} renderComponent={children => renderComponent(children, undefined, item)} />
                        </Grid>
                      </>
                    );
                  })
                ) : (
                  <div
                    style={{
                      height: "75vh",
                      width: "80vw",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <div>
                      <Spinner />
                    </div>
                  </div>
                )}
              </OverLayDrawer>
            </Grid>
          )}

          <DialogDrawer>
            {[varCustomDialogData]?.map(item => {
              return (
                <>
  {/* //varCustomDialogTitle */}
                  <Grid
                    id="mainform-grid"
                    container
                    {...item?.form?.sGridProps}
                    key={item?.form?.id}
                  >

                    <TitleHeader
                      item={item}
                      style={{ ...item?.form?.sProps }}
                      formData={item}
                      title={item?.form?.sTitle}
                      titleText={resolveHeaderText(item?.form?.sTitle)}
                      subTitle={item?.form?.sSubTitle}
                      subTitleText={resolveHeaderText(item?.form?.sSubTitle)}
                    />

                    <SSEInfoAlert enabled={isDialogDrawerOpen} />

                    <Grid container id={item?.form?.sFormName + "-menu"}>
                      <FormBar toggle={0} item={item} menu={item?.form?.sMenu} recordData={recordData} />
                    </Grid>

                    {location?.state?.dialog ? (
                      <Dialog fullWidth={true} open={true}>
                        <Box style={{ margin: "10px" }}> {renderComponent(item?.details, undefined, item)}</Box>
                      </Dialog>
                    ) : (
                      <Box style={{ marginTop: item?.form?.sMenu === "" ? "50px" : 0 }}> </Box>
                    )}
                    {isAlertPopup.open && (
                      <AlertPopup open={isAlertPopup} setClose={setIsAlertPopup} />
                    )}
                    {renderComponent(item?.details, undefined, item)}
                    <MediaDialog
                      setImageName={setImageName}
                      imagesName={imagesName}
                      setImagesIdsFromMedia={setImagesIdsFromMedia}
                      open={staticDialog}
                      setOpen={setStaticDialog}
                    />
                    {/* {JSON.stringify(lund())}dd */}
                    <FormFooter formData={item?.footer} renderComponent={children => renderComponent(children, undefined, item)} />
                  </Grid>
                </>
              );
            })}
          </DialogDrawer>
        </Grid>
      </>
    );
  };

  export default memo(Form);

